import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import "../../Borrower/AddBorrower/AddBorrower.css";
import TextField from "@mui/material/TextField";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { AiOutlineTable } from "react-icons/ai";
import Button from "@mui/material/Button";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../../Sidebar/Sidebar";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TaskIcon from '@mui/icons-material/Task';
import { url } from '../../../App'
// import { consoleUrl } from '../../../App'
import Autocomplete from '@mui/material/Autocomplete';
import Select from "react-select";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Cookies from 'js-cookie';
// import { Dialog, DialogContent, DialogTitle } from '@mui/material';

export default function LeadToBorrower() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [visible, setvisible] = useState(false);
  const [companyIdVisible, setCompanyIdVisible] = useState(false);
  const [branchIdVisible, setBranchIdVisible] = useState(false);
  const [sourceIdVisible, setSourceIdVisible] = useState(false);
  // const [ekycMode, setEkycMode] = useState('');
  // const [ekycStatus, setEkycStatus] = useState('');
  const [addressChecked, setaddressChecked] = useState(false);
  const [primaryCompanyChecked, setprimaryCompanyChecked] = useState(false);
  const [primaryBusinessChecked, setprimaryBusinessChecked] = useState(false);
  const [surrogateCompanyChecked, setsurrogateCompanyChecked] = useState(false);
  const [surrogateBusinessChecked, setsurrogateBusinessChecked] = useState(false);
  const [bankChecked, setbankChecked] = useState(false);
  const [dateofMarriage, setdateofMarriage] = useState("");
  const [motherTongue, setmotherTongue] = useState("");
  const [category, setcategory] = useState("");
  const [religion, setreligion] = useState("");
  const [familyStructure, setfamilyStructure] = useState("");
  const [totalFamilyMembers, settotalFamilyMembers] = useState("");
  // const [openDialog, setOpenDialog] = useState(false);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [sourceData, setsourceData] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const { state } = useLocation();
  const [companyIdSuperadmin, setCompanyIdSuperadmin] = useState("");
  const [branchIdSuperadmin, setBranchIdSuperadmin] = useState("");
  const [sourceIdSuperadmin, setsourceIdSuperadmin] = useState("");
  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  // const [nameOnPancard, setNameOnPancard] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [residenceType, setResidenceType] = useState("");
  const [educationalQualification, setEducationalQualification] = useState("");
  const [profession, setProfession] = useState("");
  const [companyType, setCompanyType] = useState("");
  const [age, setAge] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [borrowerEmail, setBorrowerEmail] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [permanentPinCode, setPermanentPinCode] = useState("");
  const [permanentState, setPermanentState] = useState("");
  const [permanentCity, setPermanentCity] = useState("");
  const [permanentLandmark, setPermanentLandmark] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentPinCode, setCurrentPinCode] = useState("");
  const [currentState, setCurrentState] = useState("");
  const [currentCity, setCurrentCity] = useState("");
  const [currentLandmark, setCurrentLandmark] = useState("");
  const [permanentLocality, setPermanentLocality] = useState('');
  const [currentLocality, setCurrentLocality] = useState('');
  const [permanentSubDistArr, setPermanentSubDistArr] = useState([]);
  const [currentSubDistArr, setCurrentSubDistArr] = useState([]);
  const [permanentLocalityArr, setPermanentLocalityArr] = useState([]);
  const [currentLocalityArr, setCurrentLocalityArr] = useState([]);
  const [permanentSubDist, setPermanentSubDist] = useState('');
  const [currentSubDist, setCurrentSubDist] = useState('');
  const [collectionBankType, setCollectionBankType] = useState("");
  const [disbursementBankType, setDisbursementBankType] = useState("");
  const [collectionBankAccountNumber, setCollectionBankAccountNumber] = useState("");
  const [confirmcollectionBankAccountNumber, setconfirmCollectionBankAccountNumber] =
    useState("");
  const [collectionBankIfscCode, setCollectionBankIfscCode] = useState("");
  const [collectionBankBranch, setCollectionBankBranch] = useState("");
  const [collectionBankName, setCollectionBankName] = useState("");
  const [collectionBeneficiaryName, setCollectionBeneficiaryName] = useState("");
  const [disbursementBankAccountNumber, setDisbursementBankAccountNumber] = useState("");
  const [confirmdisbursementBankAccountNumber, setconfirmdisbursementBankAccountNumber] =
    useState("");
  const [disbursementBankIfscCode, setDisbursementBankIfscCode] = useState("");
  const [disbursementBankName, setDisbursementBankName] = useState("");
  const [disbursementBankBranch, setDisbursementBankBranch] = useState("");
  const [disbursementBeneficiaryName, setDisbursementBeneficiaryName] = useState("");
  const [primaryBorrowerCompanyAddress, setprimaryBorrowerCompanyAddress] = useState("");
  const [primaryBorrowerCompanyPincode, setprimaryBorrowerCompanyPincode] = useState("");
  const [primaryBorrowerCompanyState, setprimaryBorrowerCompanyState] = useState("");
  const [primaryBorrowerCompanyCity, setprimaryBorrowerCompanyCity] = useState("");
  const [primaryBorrowerCompanySubDist, setprimaryBorrowerCompanySubDist] = useState("");
  const [primaryBorrowerCompanyLocality, setprimaryBorrowerCompanyLocality] = useState("");
  const [primaryBorrowerCompanySubDistArr, setprimaryBorrowerCompanySubDistArr] = useState([]);
  const [primaryBorrowerCompanyLocalityArr, setprimaryBorrowerCompanyLocalityArr] = useState([]);
  const [primaryBorrowerCompanyLandmark, setprimaryBorrowerCompanyLandmark] = useState("");
  const [primaryBorrowerBusinessAddress, setprimaryBorrowerBusinessAddress] = useState("");
  const [primaryBorrowerBusinessPincode, setprimaryBorrowerBusinessPincode] = useState("");
  const [primaryBorrowerBusinessState, setprimaryBorrowerBusinessState] = useState("");
  const [primaryBorrowerBusinessCity, setprimaryBorrowerBusinessCity] = useState("");
  const [primaryBorrowerBusinessSubDist, setprimaryBorrowerBusinessSubDist] = useState("");
  const [primaryBorrowerBusinessLocality, setprimaryBorrowerBusinessLocality] = useState("");
  const [primaryBorrowerBusinessSubDistArr, setprimaryBorrowerBusinessSubDistArr] = useState([]);
  const [primaryBorrowerBusinessLocalityArr, setprimaryBorrowerBusinessLocalityArr] = useState([]);
  const [primaryBorrowerBusinessLandmark, setprimaryBorrowerBusinessLandmark] = useState("");
  const [surrogateBorrowerCompanyPincode, setsurrogateBorrowerCompanyPincode] = useState("");
  const [surrogateBorrowerCompanyCity, setsurrogateBorrowerCompanyCity] = useState("");
  const [surrogateBorrowerCompanyState, setsurrogateBorrowerCompanyState] = useState("");
  const [surrogateBorrowerCompanySubDistArr, setsurrogateBorrowerCompanySubDistArr] = useState([]);
  const [surrogateBorrowerCompanyLocalityArr, setsurrogateBorrowerCompanyLocalityArr] = useState([]);
  const [surrogateBorrowerCompanyLocality, setsurrogateBorrowerCompanyLocality] = useState("");
  const [surrogateBorrowerCompanySubDist, setsurrogateBorrowerCompanySubDist] = useState("");
  const [surrogateBorrowerBusinessPincode, setsurrogateBorrowerBusinessPincode] = useState("");
  const [surrogateBorrowerBusinessCity, setsurrogateBorrowerBusinessCity] = useState("");
  const [surrogateBorrowerBusinessState, setsurrogateBorrowerBusinessState] = useState("");
  const [surrogateBorrowerBusinessSubDistArr, setsurrogateBorrowerBusinessSubDistArr] = useState([]);
  const [surrogateBorrowerBusinessLocalityArr, setsurrogateBorrowerBusinessLocalityArr] = useState([]);
  const [surrogateBorrowerBusinessLocality, setsurrogateBorrowerBusinessLocality] = useState("");
  const [surrogateBorrowerBusinessSubDist, setsurrogateBorrowerBusinessSubDist] = useState("");
  const [businessNature, setBusinessNature] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [durationWithCurrentEmployer, setDurationWithCurrentEmployer] = useState("")
  const [totalWorkExperience, setTotalWorkExperience] = useState("");
  const [legalStatus, setlegalStatus] = useState("");
  const [workplace, setworkplace] = useState("");
  const [currentWorkplace, setcurrentWorkplace] = useState("");
  const [businessID, setbusinessID] = useState("");
  const [workplaceSize, setWorkplaceSize] = useState("");
  const [numberofEmployees, setnumberofEmployees] = useState("");
  const [department, setdepartment] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [dateofJoining, setdateofJoining] = useState("");
  const [businessphoneNumber, setbusinessphoneNumber] = useState("");
  const [businessEmail, setbusinessEmail] = useState("");
  const [IfProfessional, setIfProfessional] = useState("");
  const [IfBusiness, setIfBusiness] = useState("");
  const [salaryMode, setSalaryMode] = useState("");
  const [incomeMode, setIncomeMode] = useState("");
  const [currentSalary, setCurrentSalary] = useState("");
  const [prevSalary, setPrevSalary] = useState("");
  const [officeNumber, setOfficeNumber] = useState("");
  const [officeHrNumber, setOfficeHrNumber] = useState("");
  const [industry, setIndustry] = useState("");
  const [sector, setSector] = useState("");
  const [subsector, setSubsector] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [typeOfBusiness, setTypeOfBusiness] = useState("");
  const [typeOfLoan, setTypeOfLoan] = useState("");
  const [businessIncome, setBusinessIncome] = useState("");
  const [MantriName, setMantriName] = useState("");
  const [MantriNumber, setMantriNumber] = useState("");
  const [businessVintage, setbusinessVintage] = useState("");
  const [borrowernumberOfActiveLoans, setborrowernumberOfActiveLoans] = useState("");
  const [borrowertotalMonthlyActiveEmiAmount, setborrowertotalMonthlyActiveEmiAmount] = useState("");
  const [motherMaiden, setmotherMaiden] = useState("");
  const [residingSince, setresidingSince] = useState("");
  const [applicants, setApplicants] = useState([
    { name: '', relationship: '', age: '', occupation: '', phone: '' }
  ]);
  const [references, setReferences] = useState([
    { referenceName: "", referenceNumber: "", referenceAddress: "", relationshipwithApplicant: "" },
  ]);
  const [demoTypes, setDemoTypes] = useState(['']);
  const [formData, setFormData] = useState([]);
  const [password, setPassword] = useState("");
  const [requiredTenure, setRequiredTenure] = useState("");
  const [requiredAmount, setRequiredAmount] = useState("");
  const [comment, setComment] = useState("");
  const [uniqueNumber, setUniqueNumber] = useState("");
  const [analyst, setanalyst] = useState([]);
  const [analystID, setanalystID] = useState("");
  const [manager, setmanager] = useState([]);
  const [managerID, setmanagerID] = useState("");
  const [doc_type, setdoc_type] = useState("");
  const [doc_types, setdoc_types] = useState("");
  const [base64_data, setbase64_data] = useState("");
  const [base64_datas, setbase64_datas] = useState("");
  const [borrower_aadhar_back, setborrower_aadhar_back] = useState(false);
  const [borrower_aadhar_front, setborrower_aadhar_front] = useState(false);
  const [borrower_appoinment_letter, setborrower_appoinment_letter] = useState([]);
  const [borrower_bank_report_documents, setborrower_bank_report_documents] = useState(false);
  const [borrower_bank_statement, setborrower_bank_statement] = useState([]);
  const [borrower_companyid, setborrower_companyid] = useState(false);
  const [borrower_current_address_proof, setborrower_current_address_proof] = useState(false);
  const [borrower_electricity_bill, setborrower_electricity_bill] = useState([]);
  const [borrower_misc_doc, setborrower_misc_doc] = useState([]);
  const [borrower_cibil_report, setborrower_cibil_report] = useState([]);
  const [borrower_pancard, setborrower_pancard] = useState(false);
  const [borrower_selfphoto, setborrower_selfphoto] = useState(false);
  const [mandliArr, setMandliArr] = useState([])
  const [kycDocuments, setkycDocuments] = useState([]);
  const [incomeDocuments, setincomeDocuments] = useState([]);
  const [employementDocuments, setemployementDocuments] = useState([]);
  const [businessProof, setbusinessProof] = useState([]);
  const [negativeArea, setNegativeArea] = useState({
    permanent: false,
    current: false,
    official: false
  });
  const [negativeAreaCompanyPrimary, setnegativeAreaCompanyPrimary] = useState(false)
  const [negativeAreaBusinessPrimary, setnegativeAreaBusinessPrimary] = useState(false)
  const [negativeAreaCompanySurrogate, setnegativeAreaCompanySurrogate] = useState(false)
  const [negativeAreaBusinessSurrogate, setnegativeAreaBusinessSurrogate] = useState(false)
  const [a, seta] = useState({ 'Driving License': false, 'Ration Card': false, 'Election Card': false, 'Passport': false, 'Self Attested Kyc': false, 'RC': false });
  const [b, setb] = useState({ 'ITR': "", 'Salary Slip': "", 'Milk Statement': "", 'Bank Signature Verification': false, 'GST Returns': false });
  const [c, setc] = useState({ 'Employee Id': false, 'Hr Confirmation Doc': false, 'Pf Letter': false });
  const [d, setd] = useState({ 'GST certificate': "", 'Shop Certificate': "", 'Gumastadhara': "", 'Udhyam': "", 'Partnership Deed': "", 'Company Registration Certificate': "", 'Purchase Bill': "" });
  // const [kycLink, setkycLink] = useState("");
  const [voterId, setVoterId] = useState('');
  const [borrower_inside_shop_photo, setborrower_inside_shop_photo] = useState([]);
  const [decryptButtonVisible, setDecryptButtonVisible] = useState(false);
  const [infoData, setInfoData] = useState(null);
  
  const handleMandliChange = (e, newValue) => {
    setBusinessName(newValue);
  }
  const mandliSuggestions = async (e) => {
    try {
      const { data: filteredMandlis } = await axios.get(`${url}/mandli/filter/${e.target.value}`, {
        headers: { token: token, email: email }
      })
      if (!filteredMandlis.auth) {
        toast.error(filteredMandlis.message)
        return
      }
      setMandliArr(filteredMandlis.mandli)
      return
    } catch (error) {
      return
    }
  }

  const checkNegativeArea = async (locality, stateName, name) => {
    stateName(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setNegativeArea(prevState => ({
        ...prevState,
        [name]: response.negativeArea
      }))
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativePrimaryCompanyArea = async (locality) => {
    setprimaryBorrowerCompanyLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaCompanyPrimary(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativePrimaryBusinessArea = async (locality) => {
    setprimaryBorrowerBusinessLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaBusinessPrimary(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativeSurrogateCompanyArea = async (locality) => {
    setsurrogateBorrowerCompanyLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaCompanySurrogate(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativeSurrogateBusinessArea = async (locality) => {
    setsurrogateBorrowerBusinessLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaBusinessSurrogate(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    axios
      .post(url + "/borrower/analystarray", {
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
          toast.error(res.data.message);
        } else {
          setanalyst(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    axios
      .post(url + "/borrower/managerarray", {
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
          toast.error(res.data.message);
        } else {
          setmanager(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    axios
      .post(url + "/company/dropdownarray", {
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // console.log(res);
        } else {
          // console.log(res);
          setData(res?.data);
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    axios
      .post(url + "/branch/companytobranch", {
        company_id: state.lead.lead_companycode,
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // console.log(res);
        } else {
          // console.log(res.data);
          setData2(res?.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
    axios
      .post(url + "/user/branchtouser", {
        staff_branch: state.lead.lead_branchcode,
        token: token,
        email: email,
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === false) {
        } else {
          setsourceData(res?.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          setCompanyIdVisible(res.data[0].permission.borrower_company_id);
          setBranchIdVisible(res.data[0].permission.borrower_branch_id);
          setSourceIdVisible(res.data[0].permission.borrower_source_id);
          setDecryptButtonVisible(res.data[0].permission.decrypt_aadhaar);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err.message);
        })
    };


    if (!state) {
      navigate("/");
      // console.log("No state found");
    } else {
      console.log(state, "state");
      setUniqueNumber(state.borrower_unique_number);
      setFirstName(state.lead.lead_firstname);
      setMiddleName(state?.lead.lead_middlename);
      setLastName(state?.lead.lead_lastname);
      setDateOfBirth(state.lead.lead_dob);
      setPhoneNumber(state.lead.lead_mobile);
      setBorrowerEmail(state.lead.lead_email);
      setPanNumber(state.lead.lead_pan);
      setCompanyIdSuperadmin(state.lead.lead_companycode);
      setBranchIdSuperadmin(state.lead.lead_branchcode);
      setsourceIdSuperadmin(state.lead.lead_source);
      setVoterId(state?.lead.lead_voter_no);
      // setEkycMode(state.kycMode);
      // setEkycStatus(state.kycStatus);
      setGender(state?.lead?.lead_aadhaar_dump?.gender === 'M' ? 'MALE' : state?.lead?.lead_aadhaar_dump?.gender === 'F' ? 'FEMALE' : "")
      setAadharNumber(state?.lead.lead_aadhaar_no)
    }
  }, [token, email, state, navigate]);

  const industryArray = [
    "BROKING",
    "DEFAULT",
    "DISTRIBUTOR",
    "EDUCATION",
    "ENTERTAINMENT",
    "Fintech",
    "FRANCHISEE",
    "HFC",
    "MANUFACTURING",
    "MFI",
    "NBFC",
    "OTHERS",
    "REAL ESTATE",
    "RETAILER",
    "Services",
    "TRADING",
    "WHOLE SELLER",
  ];

  const sectorArray = [
    "Agri Products",
    "Energy",
    "Entertainment & Leisure",
    "Finance",
    "FMCG",
    "Food & Beverages",
    "Gen Indl Services",
    "Hardware Equipment",
    "Healthcare",
    "Healthcare Providers",
    "Household Products",
    "Automobiles",
    "Industrial Equipment",
    "Institutions & Trusts",
    "Jewellery",
    "Media",
    "Metals",
    "Minning",
    "Non store Retail",
    "Others",
    "Paints",
    "Paper",
    "Broad line/Multiline",
    "Petroleum Products",
    "Photographic & Allied",
    "Plastics",
    "Professionsl Services",
    "Rubber",
    "Sevices",
    "Sevices Business",
    "Sevices Communication",
    "Sevices Transport",
    "Software",
    "Cement",
    "Speciality",
    "Textiles",
    "Transport",
    "Transport & Logistics",
    "Pharmaceuticals",
    "Electronics & Consumer Durables",
    "Engineering",
    "Education",
    "Animal Products",
    "Food and Beverages",
    "Chemicals",
    "IT and Computers",
    "Transportation Logistics",
    "Professional Services",
    "Specialty",
    "Computers",
    "Construction",
    "Containers & Packaging",
    "Durables",
  ];

  const subsectorArray = [
    "CoffeeandTea",
    "EdibleOils",
    "FoodGrainsincludingmilling",
    "FruitandNuts",
    "Implements",
    "Logwood&Plywoods",
    "Spices",
    "Starches",
    "sugar",
    "Vegetables",
    "Business&IndustrialENT",
    "Hotels",
    "TravelServices(otherthanticketing)",
    "TravelServices(ticketing)",
    "Cosmetic&Toiletries",
    "Detergents",
    "Groceries",
    "Tobacco",
    "MedicalEquipment",
    "DiagnosticCenters",
    "Drugsandpharma",
    "Drugsandpharma-bulkdrugsAPI",
    "Hospitals",
    "CommercialVehicles(LCV)",
    "Cycle",
    "DealersandServiceCenters-PassengerCars",
    "DealersandServiceCenters-2W/3W",
    "AutoAncillaries",
    "BallandRollerBearing",
    "Communication&Broadcasting",
    "ElectricalEquipment/RailwayEquipment",
    "Fastners",
    "Industrialmachineries",
    "MachineTools&Electrodes",
    "OfficeEquipment",
    "Transformers&Storagebatteries",
    "Valves",
    "Weldingmachineryandrelateditems",
    "Artificialorimitationjewllery",
    "Gems&Jewellery",
    "Advertising",
    "Broadcasting",
    "CableandotherTVservices",
    "Printing",
    "FinishedMetalProductslikeBrasswares",
    "Copper",
    "Fabrication",
    "IronandSteel(Scrap)",
    "Minerals&nonferrous",
    "PracticingLawyer",
    "PaperandPaperProducts",
    "LPGCylinders+dealers",
    "PetroleumProducts(lubricants)",
    "PetroleumProducts(otherthanlubricants)",
    "Paint&Varnish",
    "PetrolPumps",
    "Photographic&AlliedProducts",
    "OtherPlasticGoods",
    "PlasticFilmsandPackaging",
    "Rubber&RubberProducts",
    "BlendedYarn",
    "ReadymadeGarments",
    "Silk",
    "AirConditioners&Refrigerators",
    "ConsumerElectronics",
    "DomesticAppliances",
    "ElectricalGoods",
    "MobilePhones&Accessories",
    "Engineering&LegalServices",
    "Education-Coaching",
    "Animal&MarineFoods",
    "Beer",
    "Bakery",
    "Dairy&Poultry",
    "MedicalSupplies",
    "Packaged/Processedfood",
    "Carbonblack/CausticSoda",
    "Fertilizers&Pesticides",
    "OtherInorganicandorganicChemicals(notcovered)",
    "Petrochemicals",
    "DyesandPigments/SpecialityChemicals",
    "Computer–Education",
    "Computers",
    "InternetServices",
    "Computer–Software",
    "Air",
    "ArchitectsandInteriorDesigning",
    "CharteredAccountant",
    "Doctors-consulting",
    "EventManagement",
    "HouseKeeping&Othermanpowerrelated",
    "PlacementandHR",
    "ITES&BPO",
    "HairSalon&BeautyTreatments",
    "TechnicalConsultancyandEngineeringServices",
    "HomeFurniture&Furnishing",
    "Handicraft",
    "Luggage",
    "Opticianandaccessories",
    "OfficeSupplies&Stationery",
    "Watches",
    "OtherBuildingMaterials",
    "CementandAsbestosProducts",
    "Constructionequipment(CEQ)",
    "Granite",
    "CeramicTiles&Sanitary-ware",
    "Packaging",
  ];

  const natureOfBusinessArray = [
    "FINANCIAL INSTITUTE OTHER THAN NBFC",
    "NON-BANK FINANCIAL COMPANY",
    "FINANCIAL INTERMEDIATERIES",
    "MEDIA AND ENTERTAINMENT",
    "BANKING",
    "JEWELRY AND ORNAMENTS",
    "CHEMICALS",
    "ADVERTISING AND PROMOTION",
    "EDUCATION",
    "FREIGHT AND LOGISTICS",
    "REAL ESTATE AND BUILDER",
    "AUTOMOBILES",
    "CLOTH AND TEXTILES",
    "PHARMA AND MEDICINE",
    "ARCHITECT",
    "DOCTOR",
    "HOTEL AND HOSPITALITY",
    "IRON AND STEEL",
    "AGRICULTURE",
    "ACCOUNT CONSULTING",
    "CONTRACTOR AND FRANCHISEE",
    "ENGINEERING PRODUCTS",
    "IT AND SOFTWARE",
    "INSURANCE CIVIL CONTRACTOR",
    "TELECOM  HARDWARE AND DISTRIBUTION",
    "AGRICULTURE PROCESSING",
    "BPO AND KPO",
    "CEMENT MANUFACTURING STOCKING AND ALLIED ACTI",
    "ELECTRICAL ELECTRONICS MANUFACTURING SERVICE",
    "FMCG",
    "FURNITURE AND WOOD PRODUCTS",
    "IT HARDWARE AND PERIPHERALS",
    "NATURAL RESOURCES RELATED",
    "PAPER PRODUCTS AND ALLIED ACTIVITIES",
    "PLASTICS AND  ALLIED ACTIVITIES",
    "PUBLISHING AND PRINT MEDIA",
    "RETAIL SHOPS AND PROVISIONS RELATED",
    "RUBBER INDUSTRY  AND ALLIED PRODUCTS",
    "SHIPPING INDUSTRY",
    "OTHERS",
  ];

  const handleCheckboxAddress = (e) => {
    setaddressChecked(e.target.checked);
    if (e.target.checked === true) {
      setCurrentAddress(permanentAddress);
      setCurrentLocalityArr(permanentLocalityArr);
      setCurrentSubDistArr(permanentSubDistArr);
      setCurrentPinCode(permanentPinCode);
      setCurrentState(permanentState);
      setCurrentCity(permanentCity);
      setCurrentLandmark(permanentLandmark);
      setCurrentSubDist(permanentSubDist);
      checkNegativeArea(permanentLocality, setCurrentLocality, "current");
    }
  };

  const handlePrimaryBusinessCheckbox = (e) => {
    setprimaryBusinessChecked(e.target.checked);
    if (e.target.checked === true) {
      setprimaryBorrowerBusinessAddress(permanentAddress);
      setprimaryBorrowerBusinessPincode(permanentPinCode);
      setprimaryBorrowerBusinessState(permanentState);
      setprimaryBorrowerBusinessCity(permanentCity);
      setprimaryBorrowerBusinessSubDist(permanentSubDist);
      setprimaryBorrowerBusinessLocality(permanentLocality);
      setprimaryBorrowerBusinessLandmark(permanentLandmark);
      setprimaryBorrowerBusinessLocalityArr(permanentLocalityArr);
      setprimaryBorrowerBusinessSubDistArr(permanentSubDistArr);
    }
  };

  const handlePrimaryCompanyCheckbox = (e) => {
    setprimaryCompanyChecked(e.target.checked);
    if (e.target.checked === true) {
      setprimaryBorrowerCompanyAddress(permanentAddress);
      setprimaryBorrowerCompanyPincode(permanentPinCode);
      setprimaryBorrowerCompanyState(permanentState);
      setprimaryBorrowerCompanyCity(permanentCity);
      setprimaryBorrowerCompanySubDist(permanentSubDist);
      setprimaryBorrowerCompanyLocality(permanentLocality);
      setprimaryBorrowerCompanyLandmark(permanentLandmark);
      setprimaryBorrowerCompanyLocalityArr(permanentLocalityArr);
      setprimaryBorrowerCompanySubDistArr(permanentSubDistArr);
    }
  };

  const handleSurrogateSelfEmployeedAddress = (e) => {
    setsurrogateBusinessChecked(e.target.checked);
    console.log(e)
    console.log(e.target.checked)

    if (e.target.checked === true) {
      setsurrogateBorrowerBusinessPincode(permanentPinCode);
      setsurrogateBorrowerBusinessState(permanentState);
      setsurrogateBorrowerBusinessCity(permanentCity);
      setsurrogateBorrowerBusinessSubDist(permanentSubDist);
      setsurrogateBorrowerBusinessLocality(permanentLocality);
      setsurrogateBorrowerBusinessLocalityArr(permanentLocalityArr);
      setsurrogateBorrowerBusinessSubDistArr(permanentSubDistArr);
    }
  };

  const handleSurrogateSalariedAddress = (e) => {
    setsurrogateCompanyChecked(e.target.checked);
    console.log(e)
    console.log(e.target.checked)

    if (e.target.checked === true) {
      setsurrogateBorrowerCompanyPincode(permanentPinCode);
      setsurrogateBorrowerCompanyState(permanentState);
      setsurrogateBorrowerCompanyCity(permanentCity);
      setsurrogateBorrowerCompanySubDist(permanentSubDist);
      setsurrogateBorrowerCompanyLocality(permanentLocality);
      setsurrogateBorrowerCompanyLocalityArr(permanentLocalityArr);
      setsurrogateBorrowerCompanySubDistArr(permanentSubDistArr);
    }
  };

  const handleCheckboxBankDetails = (e) => {
    setbankChecked(e.target.checked)
    if (e.target.checked === true) {
      setDisbursementBankIfscCode(collectionBankIfscCode);
      setDisbursementBankName(collectionBankName);
      setDisbursementBankBranch(collectionBankBranch);
      setDisbursementBankType(collectionBankType);
      setDisbursementBankAccountNumber(collectionBankAccountNumber);
      setconfirmdisbursementBankAccountNumber(confirmcollectionBankAccountNumber);
      setDisbursementBeneficiaryName(collectionBeneficiaryName);
    }
  };

  const uploadSelfPhoto = (e) => {
    setOpen(true);
    console.log(e.target.files);
    let selfPhoto = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    console.log(doc_type);
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Self Photo in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    setborrower_selfphoto(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(selfPhoto[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "self_photo",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPancard = (e) => {
    console.log(e.target.files);
    setOpen(true);
    let pancard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Pan Card in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    console.log(doc_type);
    setborrower_pancard(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(pancard[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "pan_card",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          console.log(res);
          if (res.data.auth === true) {
            setPanNumber(res.data.id_no);
            // setNameOnPancard(res.data.name);
            setAge(res.data.borrower_age);
            // toast.dismiss("custom");
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
            handlePanUpdate(base64_data, doc_type);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const handlePanUpdate = (base64_data, doc_type) => {
    setTimeout(() => {
      let text = "Do you want to update PAN Details?";
      if (window.confirm(text) === true) {

        setOpen(true);
        axios
          .post(url + "/borrower/mismatchpan", {
            borrower_uniqueno: uniqueNumber,
            doc_name: "pan_card",
            doc_type: doc_type,
            token: token,
            email: email,
            fileName: base64_data,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.auth === true) {
              setPanNumber(res.data.id_no);
              // setNameOnPancard(res.data.name);
              setAge(res.data.borrower_age);
              setOpen(false);
              toast.success(res.data.message);
            } else {
              // console.log(res.data.message);
              setOpen(false);
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            // console.log(err);
            setOpen(false);
            toast.error(err.message);
          });
      } else {
        toast.error("PAN Details Not Updated");
        return;
      }
    }, 3000);
  };

  const uploadAadharCardFront = (e) => {
    console.log(e.target.files);
    let aadharCardFront = e.target.files;
    if (e.target.files[0] === undefined) {
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Aadhar Card Front in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    setdoc_type(doc_type)
    setborrower_aadhar_front(e.target.files[0].name);

    let reader = new FileReader();
    reader.readAsDataURL(aadharCardFront[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      setbase64_data(base64_data);
    };
  };

  const uploadAadharCardBack = (e) => {
    console.log(e.target.files);
    let aadharCardBack = e.target.files;
    if (e.target.files[0] === undefined) {
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Aadhar Card Back in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    setdoc_types(doc_type)
    setborrower_aadhar_back(e.target.files[0].name);

    let reader = new FileReader();
    reader.readAsDataURL(aadharCardBack[0]);
    reader.onload = (e) => {
      let base64_datas = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      setbase64_datas(base64_datas);
    };
  };

  const uploadAadharCard = (e) => {
    setOpen(true);
    axios
      .post(url + "/borrower/adddocument", {
        borrower_uniqueno: uniqueNumber,
        doc_name: "aadhar_front",
        doc_names: "aadhar_back",
        doc_type: doc_type,
        doc_types: doc_types,
        fileName: base64_data,
        fileNames: base64_datas,
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === true) {
          setAadharNumber(res.data.id_no);
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  }

  const uploadCurrentAddressProof = (e) => {
    setOpen(true);
    let currentAddressProof = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Current Address Proof in Jpg or Png or Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setborrower_current_address_proof(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(currentAddressProof[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "current_address_proof",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadDrivingLicense = (e) => {
    setOpen(true);
    let DrivingLicense = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Driving License in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    seta({ ...a, "Driving License": true });
    let reader = new FileReader();
    reader.readAsDataURL(DrivingLicense[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_driving_license",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadRationCard = (e) => {
    setOpen(true);
    let RationCard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Ration Card in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);

    seta({ ...a, "Ration Card": true });
    let reader = new FileReader();
    reader.readAsDataURL(RationCard[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_ration_card",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadElectionCard = (e) => {
    setOpen(true);
    let ElectionCard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Election Card in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    seta({ ...a, "Election Card": true });
    let reader = new FileReader();
    reader.readAsDataURL(ElectionCard[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_election_card",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPassport = (e) => {
    setOpen(true);
    let Passport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Passport in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    seta({ ...a, "Passport": true });
    let reader = new FileReader();
    reader.readAsDataURL(Passport[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_passport",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadRC = (e) => {
    setOpen(true);
    let RC = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload RC in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    seta({ ...a, "RC": true });
    let reader = new FileReader();
    reader.readAsDataURL(RC[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_rc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadGstReturns = (e) => {
    setOpen(true);
    let GstReturns = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload GST Returns in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    setb({ ...b, "GST Returns": true });
    let reader = new FileReader();
    reader.readAsDataURL(GstReturns[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_gst_returns",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadbankSignature = (e) => {
    setOpen(true);
    let BankSignature = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Bank Signature Verification in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(BankSignature[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_signature_verification",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "Bank Signature Verification": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadselfAttestedKyc = (e) => {
    setOpen(true);
    let SelfAttestedKyc = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Self Attested Kyc in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(SelfAttestedKyc[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_self_attested_kyc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            seta({ ...a, "Self Attested Kyc": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadBankStatement = (e) => {
    setOpen(true);
    let bankStatement = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Bank Statement in Jpg or Png or Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let a = [];
    a.push(e.target.files[0].name);
    // console.log(a);
    setborrower_bank_statement((prevValues) => [...prevValues, a]);

    let reader = new FileReader();
    reader.readAsDataURL(bankStatement[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_bank_statement",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err);
        });
    };
  };

  const uploadBankStatementPassword = () => {
    setOpen(true);
    axios
      .post(url + "/borrower/bankstatementpassword", {
        borrower_uniqueno: uniqueNumber,
        token: token,
        email: email,
        borrower_bank_statement_password: password,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  };

  const uploadMiscellaneousDocuments = (e) => {
    setOpen(true);
    let miscellaneousDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf" && doc_type !== "xlsx") {
      setOpen(false);
      toast.error("Please upload Miscellaneous Documents in Jpg or Png or Pdf or xlsx format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    setborrower_misc_doc((prevValues) => [...prevValues, b]);
    // console.log(borrower_misc_doc);

    let reader = new FileReader();
    reader.readAsDataURL(miscellaneousDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_misc_doc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadcibilReport = (e) => {
    setOpen(true);
    let cibilReport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    console.log(doc_type);
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Cibil Report in pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    setborrower_cibil_report((prevValues) => [...prevValues, b]);
    // console.log(borrower_cibil_report);

    let reader = new FileReader();
    reader.readAsDataURL(cibilReport[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_cibil_report",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadBankReportDocuments = (e) => {
    setOpen(true);
    let bankReportDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf" && doc_type !== "xlsx") {
      setOpen(false);
      toast.error("Please upload Bank Report Documents in Pdf or xlsx format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setborrower_bank_report_documents(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(bankReportDocuments[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "bank_report_documents",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploaditr = (e) => {
    setOpen(true);
    // console.log(e.target.files, "rohit");
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload ITR in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_itr",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res, "tt");
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "ITR": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);

          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadSalarySlip = (e) => {
    setOpen(true);
    let salarySlip = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Salary Slip in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(salarySlip[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_salaryslip",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "Salary Slip": res.data.doc_length });

          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadmilkStatement = (e) => {
    setOpen(true);
    let milkStatement = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Milk Statement in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(milkStatement[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_milkstatement",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "Milk Statement": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadCompanyId = (e) => {
    setOpen(true);
    let companyId = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Company ID in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setborrower_companyid(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(companyId[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "companyid",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadappointmentletter = (e) => {
    setOpen(true);
    let appointmentletter = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Appointment letter in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    setborrower_appoinment_letter((prevValues) => [...prevValues, b]);
    let reader = new FileReader();
    reader.readAsDataURL(appointmentletter[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_appoinment_letter",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadEmployeeId = (e) => {
    setOpen(true);
    let employeeId = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Employee Id in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setc({ ...c, "Employee Id": true });
    let reader = new FileReader();
    reader.readAsDataURL(employeeId[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_employeeid",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadhrDoc = (e) => {
    setOpen(true);
    let hrDocs = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Hr Confirmation Doc in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setc({ ...c, "Hr Confirmation Doc": true });
    let reader = new FileReader();
    reader.readAsDataURL(hrDocs[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_hr_confirmation_doc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadpfLetter = (e) => {
    setOpen(true);
    let pfLetters = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Pf Letter in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setc({ ...c, "Pf Letter": true });
    let reader = new FileReader();
    reader.readAsDataURL(pfLetters[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_pf_letter",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadGST = (e) => {
    setOpen(true);
    let GST = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload GST certificate in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(GST[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_gst_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setd({ ...d, 'GST certificate': res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadElectricBill = (e) => {
    setOpen(true);
    let electricBill = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Electricity Bill in Jpg or Png or pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    setborrower_electricity_bill((prevValues) => [...prevValues, b]);
    
    let reader = new FileReader();
    reader.readAsDataURL(electricBill[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_electricity_bill",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadBusinessPhoto = (e) => {
    setOpen(true);
    let businessPhoto = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Business Photo in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let a = [];
    a.push(e.target.files[0].name);
    // console.log(a);
    setborrower_inside_shop_photo((prevValues) => [...prevValues, a]);

    let reader = new FileReader();
    reader.readAsDataURL(businessPhoto[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_inside_shop_photo",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadShopCertificate = (e) => {
    setOpen(true);
    let ShopCertificate = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Shop Certificate in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Shop Certificate": true });
    let reader = new FileReader();
    reader.readAsDataURL(ShopCertificate[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_shop_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadGumastadhara = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Gumastadhara in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Gumastadhara": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_gumastadhara",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {

            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadUdhyam = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Udhyam in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Udhyam": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_udhyam",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {

            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPartnershipDeed = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Partnership Deed in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Partnership Deed": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_partnership_deed",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadCompanyRegistrationCertificate = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Company Registration Certificate in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Company Registration Certificate": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_company_registration_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {

            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPurchaseBill = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Purchase Bill in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/borrower/adddocument", {
          borrower_uniqueno: uniqueNumber,
          doc_name: "borrower_purchase_bill",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {

            setOpen(false);
            toast.success(res.data.message);
            setd({ ...d, 'Purchase Bill': res.data.doc_length });

          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const handleUpdatePersonalDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    axios
      .post(url + "/borrower/updatepersonal", {
        token: token,
        email: email,
        borrower_title: title,
        borrower_gender: gender,
        borrower_firstname: firstName,
        borrower_middlename: middleName,
        borrower_lastname: lastName,
        borrower_dob: dateOfBirth,
        borrower_maritalstatus: maritalStatus,
        borrower_residencetype: residenceType,
        borrower_education: educationalQualification,
        borrower_professiontype: profession,
        borrower_fathername: fathersName,
        borrower_dateofMarriage: dateofMarriage,
        borrower_mother_maiden: motherMaiden,
        borrower_motherTongue: motherTongue,
        borrower_category: category,
        borrower_religion: religion,
        borrower_familyStructure: familyStructure,
        borrower_totalFamilyMembers: totalFamilyMembers,
        borrower_uniqueno: uniqueNumber,
        borrower_companycode: companyIdSuperadmin,
        borrower_branchcode: branchIdSuperadmin,
        borrower_sourcecode: sourceIdSuperadmin
      })
      .then((res) => {
        if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  const handleCompanyId = (event) => {
    // setCompanyIdSuperadmin(event.target.value);
    // setBranchIdSuperadmin("");
    console.log(event.target.value);

    const a = data.filter((value) => {
      console.log(value)
      return value.company_id === event.target.value;
    });
    console.log(a)

    setCompanyIdSuperadmin(a[0].company_id);

    axios
      .post(url + "/branch/companytobranch", {
        company_id: a[0].company_id,
        token: token,
        email: email,
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === false) {
          toast.error("Branch is not found.");
          setData2("");
        } else {
          // console.log(res.data);
          setData2(res?.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleBranchId = (event) => {
    // setBranchIdSuperadmin(event.target.value);
    // setsourceIdSuperadmin("");
    console.log(event.target.value);

    const b = data2.filter((value) => {
      console.log(value)
      return value.branch_id === event.target.value;
    });

    setBranchIdSuperadmin(b[0].branch_id);

    axios
      .post(url + "/user/branchtouser", {
        staff_branch: b[0].branch_id,
        token: token,
        email: email,
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === false) {
          toast.error("User is not found.");
          setsourceData("");
        } else {
          setsourceData(res?.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmitAddressDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    axios
      .post(url + "/borrower/addaddress", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_permanent_address: permanentAddress,
        borrower_permanent_pincode: permanentPinCode,
        borrower_permanent_state: permanentState,
        borrower_permanent_city: permanentCity,
        borrower_permanent_subDistrict: permanentSubDist,
        borrower_permanent_locality: permanentLocality,
        borrower_permanent_landmark: permanentLandmark,
        borrower_current_address: currentAddress,
        borrower_current_pincode: currentPinCode,
        borrower_current_state: currentState,
        borrower_current_city: currentCity,
        borrower_current_subDistrict: currentSubDist,
        borrower_current_locality: currentLocality,
        borrower_current_landmark: currentLandmark,
        borrower_residing_since: residingSince,
        borrower_address_checkbox: addressChecked
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res);
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);

        setOpen(false);
        toast.error(err.message);
      });
  };

  const handleChangePermanentPinCode = (e) => {
    if (e.target.value.length <= 6) {
      setPermanentPinCode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setPermanentCity(res.data.District);
            setPermanentState(res.data.State);
            setPermanentSubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setPermanentCity("");
            setPermanentState("");
            setPermanentSubDist('')
            setPermanentSubDist('')
            setPermanentSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handlePermSubDistChange = async (e) => {
    setPermanentSubDist(e.target.value)
    try {
      const { data: localityArray } = await axios.get(`${url}/pincode/${permanentPinCode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      setPermanentLocalityArr(localityArray.locality)
    } catch (err) {
      console.log(err)
      toast.error(err.message)
    }
  }

  const handleChangeCurrentPinCode = (e) => {
    if (e.target.value.length <= 6) {
      setCurrentPinCode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setCurrentCity(res.data.District);
            setCurrentState(res.data.State);
            setCurrentSubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setCurrentCity("");
            setCurrentState("");
            setCurrentSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handleCurrentSubDistChange = async (e) => {
    setCurrentSubDist(e.target.value)
    setOpen(true)
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${currentPinCode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      setCurrentLocalityArr(localityRes.locality)
      setOpen(false)
    } catch (err) {
      console.log(err)
      setOpen(false)
    }
  }

  const handlePrimaryCompanyPincode = (e) => {
    if (e.target.value.length <= 6) {
      setprimaryBorrowerCompanyPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res)
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setprimaryBorrowerCompanyCity(res.data.District);
            setprimaryBorrowerCompanyState(res.data.State);
            setprimaryBorrowerCompanySubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setprimaryBorrowerCompanyCity("");
            setprimaryBorrowerCompanyState("");
            setprimaryBorrowerCompanySubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handlePrimaryBusinessPincode = (e) => {
    if (e.target.value.length <= 6) {
      setprimaryBorrowerBusinessPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res);
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setprimaryBorrowerBusinessCity(res.data.District);
            setprimaryBorrowerBusinessState(res.data.State);
            setprimaryBorrowerBusinessSubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setprimaryBorrowerBusinessCity("");
            setprimaryBorrowerBusinessState("");
            setprimaryBorrowerBusinessSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handleSurrogateCompanyPincode = (e) => {
    if (e.target.value.length <= 6) {
      setsurrogateBorrowerCompanyPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res);
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setsurrogateBorrowerCompanyCity(res.data.District);
            setsurrogateBorrowerCompanyState(res.data.State);
            setsurrogateBorrowerCompanySubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setsurrogateBorrowerCompanyCity("");
            setsurrogateBorrowerCompanyState("");
            setsurrogateBorrowerCompanySubDist("");
            setsurrogateBorrowerCompanySubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSurrogateBusinessPincode = (e) => {
    if (e.target.value.length <= 6) {
      setsurrogateBorrowerBusinessPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res)
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setsurrogateBorrowerBusinessCity(res.data.District);
            setsurrogateBorrowerBusinessState(res.data.State);
            setsurrogateBorrowerBusinessSubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setsurrogateBorrowerBusinessCity("");
            setsurrogateBorrowerBusinessState("");
            setsurrogateBorrowerBusinessSubDist("")
            setsurrogateBorrowerBusinessSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSubDistPrimaryCompanyChange = async (e) => {
    console.log(e.target.value)
    setprimaryBorrowerCompanySubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${primaryBorrowerCompanyPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setprimaryBorrowerCompanyLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistPrimaryBusinessChange = async (e) => {
    console.log(e.target.value)
    setprimaryBorrowerBusinessSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${primaryBorrowerBusinessPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setprimaryBorrowerBusinessLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistSurrogateCompanyChange = async (e) => {
    console.log(e.target.value)
    setsurrogateBorrowerCompanySubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${surrogateBorrowerCompanyPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setsurrogateBorrowerCompanyLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistSurrogateBusinessChange = async (e) => {
    console.log(e.target.value)
    setsurrogateBorrowerBusinessSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${surrogateBorrowerBusinessPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setsurrogateBorrowerBusinessLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }
//old
  // const handleChangeCollectionBankIfscCode = (e) => {
  //   if (e.target.value.length <= 11) {
  //     setCollectionBankIfscCode(e.target.value);
  //   }
  //   if (e.target.value.length === 11) {
  //     axios
  //       .post(consoleUrl + "/credin/v4", {
  //         IFSC: e.target.value,
  //       })
  //       .then((res) => {
  //         if (res.data.Message === "Bank Details Found") {
  //           toast.success(res.data.Message);
  //           setCollectionBankName(res.data.Bank);
  //           setCollectionBankBranch(res.data.Branch);
  //         } else {
  //           toast.error(res.data.Message);
  //           setCollectionBankName("");
  //           setCollectionBankBranch("");
  //         }
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };

  //new
  const handleChangeCollectionBankIfscCode = (e) => {
    console.log(e.target.value,"e")
    if (e.target.value.length <= 11) {
      setCollectionBankIfscCode(e.target.value);
    }
    if (e.target.value.length === 11) {
      axios
        .post(url + "/api/fetch/bank/details", {
          IFSC: e.target.value,
          token: token,
          email: email,
        })
        .then((res) => {
          console.log(res,"res")
          if (res.data.success) {
            toast.success("Bank Details Found");
            setCollectionBankName(res.data.bank);
            setCollectionBankBranch(res.data.branch);
          } else {
            toast.error(res.data.message);
            setCollectionBankName("");
            setCollectionBankBranch("");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

//old
  // const handleChangeDisbursementBankIfscCode = (e) => {
  //   if (e.target.value.length <= 11) {
  //     setDisbursementBankIfscCode(e.target.value);
  //   }
  //   if (e.target.value.length === 11) {
  //     axios
  //       .post(consoleUrl + "/credin/v4", {
  //         IFSC: e.target.value,
  //       })
  //       .then((res) => {
  //         if (res.data.Message === "Bank Details Found") {
  //           toast.success(res.data.Message);
  //           setDisbursementBankName(res.data.Bank);
  //         } else {
  //           toast.error(res.data.Message);
  //           setDisbursementBankName("");
  //         }
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };

  //new
  const handleChangeDisbursementBankIfscCode = (e) => {
    console.log(e.target.value,"e")
    if (e.target.value.length <= 11) {
      setDisbursementBankIfscCode(e.target.value);
    }
    if (e.target.value.length === 11) {
      axios
        .post(url + "/api/fetch/bank/details", {
          IFSC: e.target.value,
          token: token,
          email: email,
        })
        .then((res) => {
          console.log(res,"res")
          if (res.data.success) {
            toast.success("Bank Details Found");
            setDisbursementBankName(res.data.bank);
            setDisbursementBankBranch(res.data.branch);
          } else {
            toast.error(res.data.message);
            setDisbursementBankName("");
            setDisbursementBankBranch("");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSubmitBankDetails = (e) => {
    e.preventDefault();
    if (collectionBankAccountNumber !== confirmcollectionBankAccountNumber) {
      toast.error("Collection Bank Account Number and Confirm Collection Bank Account Number should be same");
    }
    else if (disbursementBankAccountNumber !== confirmdisbursementBankAccountNumber) {
      toast.error("Disbursement Bank Account Number and Confirm Disbursement Bank Account Number should be same");
    }
    else {
      setOpen(true);
      axios
        .post(url + "/borrower/addbank", {
          borrower_collection_bank_ifsc: collectionBankIfscCode,
          borrower_collection_bank_name: collectionBankName,
          borrower_collection_bank_branch: collectionBankBranch,
          borrower_collection_bank_type: collectionBankType,
          borrower_collection_bank_account: collectionBankAccountNumber,
          // borrower_confirm_collection_bank_account: confirmcollectionBankAccountNumber,
          borrower_collection_beneficiary_name: collectionBeneficiaryName,
          borrower_disbursement_bank_ifsc: disbursementBankIfscCode,
          borrower_disbursement_bank_name: disbursementBankName,
          borrower_disbursement_bank_branch: disbursementBankBranch,
          borrower_disbursement_bank_type: disbursementBankType,
          borrower_disbursement_bank_account: disbursementBankAccountNumber,
          // borrower_confirm_disbursement_bank_account: confirmdisbursementBankAccountNumber,
          borrower_disbursement_beneficiary_name: disbursementBeneficiaryName,
          borrower_bank_details_checkbox: bankChecked,
          token: token,
          email: email,
          borrower_uniqueno: uniqueNumber,
        })
        .then((res) => {
          if (res.data.auth === true) {
            // console.log(res);
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    }
  };

  const handleReferenceDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    const allReferenceData = references.map((reference) => ({
      referenceName: reference.referenceName,
      referenceNumber: reference.referenceNumber,
      referenceAddress: reference.referenceAddress,
      relationshipwithApplicant: reference.relationshipwithApplicant,
    }));
    axios
      .post(url + "/borrower/addreference", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_references_details: allReferenceData,
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res);
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);

        setOpen(false);
        toast.error(err.message);
      });
  };

  const handlePrimaryBusinessDetails = (e) => {
    e.preventDefault();
    const primaryformData = {
      NatureofEmployer: businessNature,
      EmployerCompanyType: companyType,
      EmployerName: employerName,
      Department: department,
      Designation: designationName,
      DurationWithCurrentEmployerInMonths: durationWithCurrentEmployer,
      TotalWorkExperienceInMonths: totalWorkExperience,
      SalaryMode: salaryMode,
      CurrentSalary: currentSalary,
      PreviousSalary: prevSalary,
      OfficeNumber: officeNumber,
      OfficeHrNumber: officeHrNumber,
      EmployeeCode: employeeCode,
      JoiningDate: dateofJoining,
      Industry: industry,
      Sector: sector,
      Subsector: subsector,
      CompanyAddress: primaryBorrowerCompanyAddress,
      CompanyPinCode: primaryBorrowerCompanyPincode,
      CompanyState: primaryBorrowerCompanyState,
      CompanyCity: primaryBorrowerCompanyCity,
      CompanySubDistrict: primaryBorrowerCompanySubDist,
      CompanyLocality: primaryBorrowerCompanyLocality,
      CompanyLandmark: primaryBorrowerCompanyLandmark,
      PrimaryCompanyChecked: primaryCompanyChecked,
      BusinessType: typeOfBusiness,
      BusinessName: businessName,
      MantriName: MantriName,
      MantriNumber: MantriNumber,
      IncomeMode: incomeMode,
      BusinessIncome: businessIncome,
      BusinessPhoneNumber: businessphoneNumber,
      BusinessEmail: businessEmail,
      IfProfessional: IfProfessional,
      IfBusiness: IfBusiness,
      // LegalStatus: legalStatus,
      LegalStatus: typeOfLoan === "CATTLE LOAN" ? "PROPRIETORSHIP" : legalStatus,
      Workplace: workplace,
      CurrentWorkplace: currentWorkplace,
      // BusinessID: businessID,
      BusinessID: typeOfLoan === "CATTLE LOAN" ? "Milk Statement" : businessID,
      WorkplaceSize: workplaceSize,
      NumberofEmployees: numberofEmployees,
      BusinessVintage: businessVintage,
      BusinessAddress: primaryBorrowerBusinessAddress,
      BusinessPincode: primaryBorrowerBusinessPincode,
      BusinessState: primaryBorrowerBusinessState,
      BusinessCity: primaryBorrowerBusinessCity,
      BusinessSubDist: primaryBorrowerBusinessSubDist,
      BusinessLocality: primaryBorrowerBusinessLocality,
      BusinessLandmark: primaryBorrowerBusinessLandmark,
      PrimaryBusinessChecked: primaryBusinessChecked,
      TypeOfLoan:typeOfLoan
    };

    console.log(primaryformData)

    axios
      .post(url + "/borrower/primary/details", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_primary_business_details: primaryformData
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const handleObligationDetails = (e) => {
    e.preventDefault();
    axios
      .post(url + "/borrower/obligation/details", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_number_of_active_loans: borrowernumberOfActiveLoans,
        borrower_total_monthly_active_emi_amount: borrowertotalMonthlyActiveEmiAmount
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const handleSubmitExtraDetails = (e) => {
    e.preventDefault();

    setOpen(true);
    axios
      .post(url + "/borrower/addextra", {
        borrower_uniqueno: uniqueNumber,
        token: token,
        email: email,
        borrower_require_tenure: requiredTenure,
        borrower_require_amt: requiredAmount,
        borrower_comment: comment,
        borrower_loan_analyst_access: analystID,
        borrower_loan_manager_access: managerID,
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res);
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false)
        toast.error(err.message);
      });
  };

  const handleToggleBorrowerStatus = () => {
    setOpen(true);
    // console.log("Changing Borrower Status...");
    axios
      .post(url + "/borrower/completestatus", {
        borrower_uniqueno: uniqueNumber,
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === true) {

          setOpen(false);
          toast.success(res.data.message);
          setTimeout(() => {
            navigate("/borrower/view")
          }, 3000);
        } else {

          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  const handleAnalyst = (event) => {
    // console.log(event.target.value);
    setanalystID(event.target.value);
  };

  const handleManager = (event) => {
    // console.log(event.target.value);
    setmanagerID(event.target.value);
  };

  const kyc = [
    { value: "Driving License", label: "Driving License", id: "Driving License" },
    { value: "Ration Card", label: "Ration Card", id: "Ration Card" },
    { value: "Election Card", label: "Election Card", id: "Election Card" },
    { value: "Passport", label: "Passport", id: "Passport" },
    { value: "Self Attested Kyc", label: "Self Attested Kyc", id: "Self Attested Kyc" },
    { value: "RC", label: "RC", id: "RC" }
  ];

  var Income;

  if (profession === "SALARIED") {
    Income = [
      { value: "ITR", label: "ITR", id: "ITR" },
      { value: "Salary Slip", label: "Salary Slip", id: "Salary Slip" },
      { value: "Bank Signature Verification", label: "Bank Signature Verification", id: "Bank Signature Verification" },
    ];
  } else {
    Income = [
      { value: "ITR", label: "ITR", id: "ITR" },
      { value: "Milk Statement", label: "Milk Statement", id: "Milk Statement" },
      { value: "Bank Signature Verification", label: "Bank Signature Verification", id: "Bank Signature Verification" },
      { value: "GST Returns", label: "GST Returns", id: "GST Returns" },
    ];
  }

  const Employement = [
    { value: "Employee Id", label: "Employee Id", id: "Employee Id" },
    { value: "Hr Confirmation Doc", label: "Hr Confirmation Doc", id: "Hr Confirmation Doc" },
    { value: "Pf Letter", label: "Pf Letter", id: "Pf Letter" },
  ];

  const Business = [
    { value: "GST certificate", label: "GST certificate", id: "GST certificate" },
    { value: "Shop Certificate", label: "Shop Certificate", id: "Shop Certificate" },
    { value: "Gumastadhara", label: "Gumastadhara", id: "Gumastadhara" },
    { value: "Udhyam", label: "Udhyam", id: "Udhyam" },
    { value: "Partnership Deed", label: "Partnership Deed", id: "Partnership Deed" },
    { value: "Company Registration Certificate", label: "Company Registration Certificate", id: "Company Registration Certificate" },
    { value: "Purchase Bill", label: "Purchase Bill", id: "Purchase Bill" },
  ];

  const abc = (e) => {
    // console.log(e,"aa");
    if (e.target.name === "Driving License") {
      uploadDrivingLicense(e);
    }
    if (e.target.name === "Ration Card") {
      uploadRationCard(e);
    }
    if (e.target.name === "Election Card") {
      uploadElectionCard(e);
    }
    if (e.target.name === "Passport") {
      uploadPassport(e);
    }
    if (e.target.name === "Self Attested Kyc") {
      uploadselfAttestedKyc(e);
    }
    if (e.target.name === "RC") {
      uploadRC(e);
    }
  }

  const bac = (e) => {
    // console.log(e,"aa");
    if (e.target.name === "ITR") {
      uploaditr(e);
    }
    if (e.target.name === "Salary Slip") {
      uploadSalarySlip(e);
    }
    if (e.target.name === "Milk Statement") {
      uploadmilkStatement(e);
    }
    if (e.target.name === "Bank Signature Verification") {
      uploadbankSignature(e);
    }
    if (e.target.name === "GST Returns") {
      uploadGstReturns(e);
    }
  }

  const bcc = (e) => {
    // console.log(e,"aa");
    if (e.target.name === "Employee Id") {
      uploadEmployeeId(e);
    }
    if (e.target.name === "Hr Confirmation Doc") {
      uploadhrDoc(e);
    }
    if (e.target.name === "Pf Letter") {
      uploadpfLetter(e);
    }
  }

  const businessRegistration = (e) => {
    // console.log(e,"aa");
    if (e.target.name === "GST certificate") {
      uploadGST(e);
    }
    if (e.target.name === "Shop Certificate") {
      uploadShopCertificate(e);
    }
    if (e.target.name === "Gumastadhara") {
      uploadGumastadhara(e);
    }
    if (e.target.name === "Udhyam") {
      uploadUdhyam(e);
    }
    if (e.target.name === "Partnership Deed") {
      uploadPartnershipDeed(e);
    }
    if (e.target.name === "Company Registration Certificate") {
      uploadCompanyRegistrationCertificate(e);
    }
    if (e.target.name === "Purchase Bill") {
      uploadPurchaseBill(e);
    }
  }

  // console.log("find",a);

  const KycBox = (label) => {
    // console.log(label);
    if (label === "Bank Signature Verification" || label === "Self Attested Kyc") {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input type="file"  name={label} onChange={(e) => abc(e)} />
          <div>
            {a[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
            {a[label] ? `(${a[label]})` : ""}
          </div>
          <br />
        </div>
      );
    }

    else {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input type="file"  name={label} onChange={(e) => abc(e)} />
          <div>
            {a[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
          </div>
          <br />
        </div>
      );
    }
  };

  const incomeBox = (label) => {
    // console.log(label);
    return (
      <div className="input-item-kyc">
        <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
        <input
          type="file"
          
          name={label}
          onChange={(e) => bac(e)}
        />
        <div>
          {b[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
          {b[label] ? `(${b[label]})` : ""}
        </div>
        <br />
      </div>
    );
  };

  const employeBox = (label) => {
    // console.log(label);
    return (
      <div className="input-item-kyc">
        <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
        <input
          type="file"
          
          name={label}
          onChange={(e) => bcc(e)}
        />
        {c[label] ? (
          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
        ) : (
          ""
        )}
        <br />
      </div>
    );
  };

  const businessBox = (label) => {
    // console.log(label);
    if (label === "GST certificate" || label === "Purchase Bill") {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input type="file"  name={label} onChange={(e) => businessRegistration(e)} />
          <div>
            {d[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
            {d[label] ? `(${d[label]})` : ""}
          </div>
          <br />
        </div>
      );
    }

    else {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input
            type="file"
            
            name={label}
            onChange={(e) => businessRegistration(e)}
          />
          <div>
            {d[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
          </div>
          <br />
        </div>
      );
    }
  };

  const handlekycdocuments = (e) => {
    // console.log("kyc", e);
    const fetchFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(fetchFees);
    setkycDocuments(fetchFees);
  };

  const handleincomedocuments = (e) => {
    // console.log("income", e);
    const incomeFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(incomeFees);
    setincomeDocuments(incomeFees);
  };

  const handleemployeedocuments = (e) => {
    // console.log("emp", e);
    const employeFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(employeFees);
    setemployementDocuments(employeFees);
  };

  const handlebusinessdocuments = (e) => {
    // console.log("emp", e);
    const businessFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(businessFees);
    setbusinessProof(businessFees);
  };

  /*
  const handleEkyc = (ekyc) => {
    setOpen(true);
    console.log(ekyc);
    axios
      .post(url + `/ekyc/${ekyc}`, {
        borrowerId: uniqueNumber,
        token: token,
        email: email,
        customer: "Borrower"
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === '1') {
          setOpenDialog(true);
        } else if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.message);
          setkycLink(res.data.kycLink);
        } else {
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  const handleChoice = async (choice) => {
    console.log("Selected choice", choice);
    let userChoice;
    if (!choice) {
      userChoice = 'eKyc'
    } else {
      userChoice = choice;
    }
    let name = firstName + ' ' + lastName
    try {
      setOpenDialog(false);
      const callKycApi = await axios.post(url + "/borrower/initiatekyc", {
        kycType: userChoice,
        borrowerNo: uniqueNumber,
        borrowerMobile: phoneNumber,
        borrowerName: name
      })

      if (callKycApi.data.auth === true) {
        console.log('arrived');
        toast.success('KYC Reinitiated', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
        });
      }
      if (userChoice === 'eKyc') {
        setEkycMode('DIGIO EKYC')
      } else {
        setEkycMode('DIGIO PHYSICAL')
      }
      setEkycStatus('INITIATED');
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  function copyLinkToClipboard() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(kycLink)
        .then(() => {
          toast.success('Link copied to clipboard successfully');
        })
        .catch((error) => {
          toast.error('Error copying Link to clipboard:', error);
        });
    } else {
      toast.error('Clipboard API not supported or writeText property not available');
    }
  }
  */

  // const handlefirstName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setFirstName(e.target.value);
  //   }
  // };
  // const handlemiddleName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setMiddleName(e.target.value);
  //   }
  // };

  // const handlelastName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setLastName(e.target.value);
  //   }
  // };

  const fatherName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setFathersName(e.target.value);
    }
  };

  // const FriendReferenceName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setFriendReferenceName(e.target.value);
  //   }
  // };

  // const RelativeReferenceName = (e) => {
  //   var reg = /^([a-zA-Z\s]{0,100})$/;
  //   // console.log(e.target.value);
  //   if (reg.test(e.target.value)) {
  //     setRelativeReferenceName(e.target.value);
  //   }
  // };

  const EmployerName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setEmployerName(e.target.value);
    }
  };
  const handlebusinessName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setBusinessName(e.target.value);
    }
  };

  const handleAddApplicant = () => {
    setApplicants([...applicants, { name: '', relationship: '', age: '', occupation: '', phone: '' }]);
  };

  const handleApplicantInputChange = (index, e) => {
    const { name, value } = e.target;
    const newApplicants = [...applicants];
    newApplicants[index][name] = value;
    setApplicants(newApplicants);
  };

  const handleApplicantDetails = (event) => {
    event.preventDefault();
    setOpen(true);
    const allApplicantsData = applicants.map((applicant) => ({
      name: applicant.name,
      relationship: applicant.relationship,
      age: applicant.age,
      occupation: applicant.occupation,
      phone: applicant.phone
    }));

    console.log(allApplicantsData);
    axios
      .post(url + "/borrower/applicant/details", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_applicant_family_details: allApplicantsData
      })
      .then((res) => {
        if (res.data.auth === true) {
          console.log(res);
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  };

  const handleAddReference = () => {
    setReferences([
      ...references,
      { referenceName: "", referenceNumber: "", referenceAddress: "", relationshipwithApplicant: "" },
    ]);
  };

  const handleReferenceInputChange = (index, e) => {
    console.log(index)
    console.log(e.target.name)
    console.log(e.target.value)

    const { name, value } = e.target;
    const newReferences = [...references];
    newReferences[index][name] = value;
    setReferences(newReferences);
  };

  const handleAddSurrogate = () => {
    setDemoTypes([...demoTypes, '']);
    setFormData([...formData, {}]);
  };

  const handleSurrogateProfession = (index, value) => {
    const newDemoTypes = [...demoTypes];
    newDemoTypes[index] = value;
    setDemoTypes(newDemoTypes);
  };

  const handleSurrogateInputChange = (index, fieldName, value) => {
    const newFormData = [...formData];
    newFormData[index] = { ...newFormData[index], [fieldName]: value }; // Update or create object for the specific index and field
    setFormData(newFormData);
  };

  const handleSurrogateDetails = (e) => {
    e.preventDefault();
    const inputFieldsData = demoTypes.map((demoType, index) => {
      const data = {
        professionType: demoType,
      };
      if (demoType === "SELF-EMPLOYED") {
        data.TypeOfBusiness = formData[index]?.TypeOfBusiness || "";
        data.BusinessName = formData[index]?.BusinessName || "";
        data.MantriName = formData[index]?.MantriName || "";
        data.MantriNumber = formData[index]?.MantriNumber || "";
        data.BusinessIncome = formData[index]?.BusinessIncome || "";
        data.BusinessIncomeMode = formData[index]?.BusinessIncomeMode || "";
        data.BusinessPhone = formData[index]?.BusinessPhone || "";
        data.BusinessEmail = formData[index]?.BusinessEmail || "";
        data.BusinessYears = formData[index]?.BusinessYears || "";
        data.IfProfessional = formData[index]?.IfProfessional || "";
        data.Ifbusiness = formData[index]?.Ifbusiness || "";
        data.LegalStatus = formData[index]?.LegalStatus || "";
        data.Workplace = formData[index]?.Workplace || "";
        data.CurrentWorkplace = formData[index]?.CurrentWorkplace || "";
        data.BusinessId = formData[index]?.BusinessId || "";
        data.WorkplaceSize = formData[index]?.WorkplaceSize || "";
        data.NumberofEmployees = formData[index]?.NumberofEmployees || "";
        data.BusinessAddress = formData[index]?.BusinessAddress || "";
        data.BusinessPinCode = surrogateBorrowerBusinessPincode;
        data.BusinessState = surrogateBorrowerBusinessState;
        data.BusinessCity = surrogateBorrowerBusinessCity;
        data.BusinessSubDist = surrogateBorrowerBusinessSubDist;
        data.BusinessLocality = surrogateBorrowerBusinessLocality;
        data.BusinessLandmark = formData[index]?.BusinessLandmark || "";
        data.BusinessCheckbox = surrogateBusinessChecked;
      } else {
        data.NatureOfBusiness = formData[index]?.NatureOfBusiness || "";
        data.CompanyType = formData[index]?.CompanyType || "";
        data.EmployerName = formData[index]?.EmployerName || "";
        data.Department = formData[index]?.Department || "";
        data.DesignationName = formData[index]?.DesignationName || "";
        data.DurationWithCurrentEmployer = formData[index]?.DurationWithCurrentEmployer || "";
        data.SalaryMode = formData[index]?.SalaryMode || "";
        data.CurrentSalary = formData[index]?.CurrentSalary || "";
        data.PrevSalary = formData[index]?.PrevSalary || "";
        data.JobVintage = formData[index]?.JobVintage || "";
        data.EmployeeCode = formData[index]?.EmployeeCode || "";
        data.Dateofjoining = formData[index]?.Dateofjoining || "";
        data.OfficeNumber = formData[index]?.OfficeNumber || "";
        data.OfficeHrNumber = formData[index]?.OfficeHrNumber || "";
        data.Industry = formData[index]?.Industry || "";
        data.Sector = formData[index]?.Sector || "";
        data.Subsector = formData[index]?.Subsector || "";
        data.CompanyAddress = formData[index]?.CompanyAddress || "";
        data.CompanyPinCode = surrogateBorrowerCompanyPincode;
        data.CompanyState = surrogateBorrowerCompanyState;
        data.CompanyCity = surrogateBorrowerCompanyCity;
        data.CompanySubDist = surrogateBorrowerCompanySubDist;
        data.CompanyLocality = surrogateBorrowerCompanyLocality;
        data.CompanyLandmark = formData[index]?.CompanyLandmark || "";
        data.CompanyCheckbox = surrogateCompanyChecked;
      }
      return data;
    });

    console.log(inputFieldsData);
    axios
      .post(url + "/borrower/surrogate/details", {
        token: token,
        email: email,
        borrower_uniqueno: uniqueNumber,
        borrower_surrogate_business_details: inputFieldsData
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const relationshipOptions = [
    { value: 'FRIEND', label: 'Friend' },
    { value: 'BROTHER', label: 'Brother' },
    { value: 'SISTER', label: 'Sister' },
    { value: 'FATHER', label: 'Father' },
    { value: 'MOTHER', label: 'Mother' },
    { value: 'SON', label: 'Son' },
    { value: 'DAUGHTER', label: 'Daughter' },
    { value: 'SON-IN-LAW', label: 'Son-In-law' },
    { value: 'SISTER-IN-LAW', label: 'Sister-in-law' },
    { value: 'FATHER-IN-LAW', label: 'Father-in-law' },
    { value: 'MOTHER-IN-LAW', label: 'Mother-In-Law' },
    { value: 'SPOUSE', label: 'Spouse' },
  ];

  const handleDecryptClick = async (value, requestor) => {
    console.log(value);
    console.log(requestor);

    try {
      const decrypt = await axios.post(url + '/borrower/decryptAadhaar', {
        email: email,
        token: token,
        id: value,
        requestor: requestor
      })

      console.log(decrypt.data);
      if (decrypt.data.auth === true) {

        toast.success('Decrypted');
        setInfoData(decrypt.data.message);
        return;

      } else {

        toast.error(decrypt.data.message);
        return;
      }

    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <AiOutlineTable />
              Lead to Borrower
            </h2>
            <div className="container-add-borrower">
              <div className="fields-add-borrower">
                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Personal Details</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleUpdatePersonalDetails}>
                    <AccordionDetails className="personal-details">
                      <div className="input-item">
                        <label>Title*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          name="title"
                          
                          value={title}
                          size="small"
                          onChange={(e) => setTitle(e.target.value)}
                        >
                          <MenuItem value="MR">Mr</MenuItem>
                          <MenuItem value="MRS">Mrs</MenuItem>
                          <MenuItem value="MS">MS</MenuItem>
                          <MenuItem value="OTHERS">Others</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>Gender*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="gender"
                          value={gender}
                          size="small"
                          onChange={(e) => setGender(e.target.value)}
                          // disabled
                        >
                          <MenuItem value="MALE">Male</MenuItem>
                          <MenuItem value="FEMALE">Female</MenuItem>
                          <MenuItem value="TRANSGENDER">Transgender</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>First Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          
                          name="first-name"
                          // onChange={(e) => handlefirstName(e)}
                          value={firstName}
                          placeholder="First Name"
                          size="small"
                          disabled
                        />
                      </div>
                      <div className="input-item">
                        <label>Middle Name</label>
                        <br />
                        <TextField
                          className="input-field"
                          // onChange={(e) => handlemiddleName(e)}
                          value={middleName}
                          name="middle-name"
                          placeholder="Middle Name"
                          size="small"
                          disabled
                        />
                      </div>
                      <div className="input-item">
                        <label>Last Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          
                          name="last-name"
                          // onChange={(e) => handlelastName(e)}
                          value={lastName}
                          placeholder="Last Name"
                          size="small"
                          disabled
                        />
                      </div>
                      <div className="input-item">
                        <label>Date of Birth*</label>
                        <br />
                        <TextField
                          className="input-field"
                          type="date"
                          
                          name="dob"
                          // onChange={(e) => setDateOfBirth(e.target.value)}
                          value={dateOfBirth}
                          size="small"
                          disabled
                        />
                      </div>
                      <div className="input-item">
                        <label>Marital Status*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="marital-status"
                          value={maritalStatus}
                          size="small"
                          onChange={(e) => setMaritalStatus(e.target.value)}
                        >
                          <MenuItem value="MARRIED">Married</MenuItem>
                          <MenuItem value="SINGLE">Single</MenuItem>
                          <MenuItem value="WIDOW">Widow</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>Residence Type*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="residence-type"
                          value={residenceType}
                          size="small"
                          onChange={(e) => setResidenceType(e.target.value)}
                        >
                          <MenuItem value="RENTED">RENTED</MenuItem>
                          <MenuItem value="OWNED">OWNED</MenuItem>
                          <MenuItem value="PARENTAL">PARENTAL</MenuItem>
                          <MenuItem value="COMPANY PROVIDED">
                            COMPANY PROVIDED
                          </MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Educational Qualification*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="educational-qualification"
                          value={educationalQualification}
                          size="small"
                          onChange={(e) =>
                            setEducationalQualification(e.target.value)
                          }
                        >
                          <MenuItem value="ILLITERATE">ILLITERATE</MenuItem>
                          <MenuItem value="10TH">10TH</MenuItem>
                          <MenuItem value="12TH">12TH</MenuItem>
                          <MenuItem value="GRADUATE">GRADUATE</MenuItem>
                          <MenuItem value="POST-GRADUATE">
                            POST-GRADUATE
                          </MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>Profession Type*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="profession-type"
                          value={profession}
                          size="small"
                          onChange={(e) => setProfession(e.target.value)}
                        >
                          <MenuItem value="SALARIED">SALARIED</MenuItem>
                          <MenuItem value="SELF-EMPLOYED">
                            SELF-EMPLOYED
                          </MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Mobile Number*</label>
                        <br />
                        <TextField
                          className="input-field"
                          name="mobile-number"
                          value={phoneNumber}
                          disabled
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          placeholder="Mobile Number"
                          size="small"
                          type="number"
                        />
                      </div>
                      <div className="input-item">
                        <label>E-mail*</label>
                        <br />
                        <TextField
                          className="input-field"
                          name="email"
                          value={borrowerEmail}
                          onChange={(e) => setBorrowerEmail(e.target.value)}
                          placeholder="E-mail"
                          disabled
                          size="small"
                          type="email"
                        />
                      </div>
                      <div className="input-item">
                        <label>Father's/Spouse's name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          name="father-name"
                          
                          value={fathersName}
                          onChange={(e) => fatherName(e)}
                          placeholder="Father's/Spouse's name"
                          size="small"
                        />
                      </div>
                      {maritalStatus === "MARRIED" ? (
                        <div className="input-item">
                          <label htmlFor="monthly-income">Date Of Marriage*</label>
                          <TextField
                            className="lms-input-field"
                            size="small"
                            
                            type="date"
                            placeholder="Date Of Marriage"
                            value={dateofMarriage}
                            variant="outlined"
                            id="monthly-income"
                            onChange={(e) =>
                              setdateofMarriage(e.target.value)
                            }
                            name="monthly-income"
                          />
                        </div>
                      ) : ""}

                      <div className="input-item">
                        <label>Mother’s Maiden name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={motherMaiden}
                          
                          name="number-of-active-loans"
                          onChange={(e) => setmotherMaiden(e.target.value)}
                          placeholder="Mother’s Maiden Name"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Mother Tongue*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="profession-type"
                          value={motherTongue}
                          size="small"
                          onChange={(e) => setmotherTongue(e.target.value)}
                        >
                          <MenuItem value="HINDI">Hindi</MenuItem>
                          <MenuItem value="GUJARATI">
                            Gujarati
                          </MenuItem>
                          <MenuItem value="ENGLISH">
                            English
                          </MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Category*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="profession-type"
                          value={category}
                          size="small"
                          onChange={(e) => setcategory(e.target.value)}
                        >
                          <MenuItem value="GENERAL">GENERAL</MenuItem>
                          <MenuItem value="SC">
                            SC
                          </MenuItem>
                          <MenuItem value="ST">
                            ST
                          </MenuItem>
                          <MenuItem value="OBC">
                            OBC
                          </MenuItem>
                          <MenuItem value="OTHER">
                            OTHER
                          </MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Religion*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="profession-type"
                          value={religion}
                          size="small"
                          onChange={(e) => setreligion(e.target.value)}
                        >
                          <MenuItem value="HINDU">Hindu</MenuItem>
                          <MenuItem value="MUSLIM">
                            Muslim
                          </MenuItem>
                          <MenuItem value="SIKH">Sikh</MenuItem>
                          <MenuItem value="CHRISTIAN">Christian</MenuItem>
                          <MenuItem value="JAIN">Jain</MenuItem>
                          <MenuItem value="BUDDHISM">Buddhism</MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Family Structure*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="profession-type"
                          value={familyStructure}
                          size="small"
                          onChange={(e) => setfamilyStructure(e.target.value)}
                        >
                          <MenuItem value="JOINTLY WITH PARENTS">Jointly with Parents</MenuItem>
                          <MenuItem value="JOINTLY WITH RELATIVES">
                            Jointly with Relatives
                          </MenuItem>
                          <MenuItem value="NUCLEAR">Nuclear</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>Total Family Members*</label>
                        <br />
                        <TextField
                          className="input-field"
                          
                          type="number"
                          name="last-name"
                          onChange={(e) => settotalFamilyMembers(e.target.value)}
                          value={totalFamilyMembers}
                          placeholder="Total Family Members"
                          size="small"
                        />
                      </div>
                      <div className="input-item">
                        <label>Voter ID</label>
                        <br />
                        <TextField
                          className="input-field"
                          name="voterId"
                          value={voterId}
                          disabled
                          // onChange={(e) => setVoterId(e.target.value)}
                          // placeholder="Mobile Number"
                          size="small"
                          type="text"
                        />
                      </div>
                      {(companyIdVisible || visible) && (
                        <div className="input-item">
                          <label>Company Id*</label>
                          <TextField
                            name="company-id"
                            
                            className="input-field"
                            select
                            size="small"
                            onChange={handleCompanyId}
                            value={companyIdSuperadmin}
                            disabled
                          >
                            {data.length > 0 &&
                              data.map((data, id) => (
                                <MenuItem
                                  key={id}
                                  value={data.company_id}
                                  disabled={!data.is_active}
                                >
                                  {data.company_id + " " + data.company_name}
                                </MenuItem>
                              ))}
                          </TextField>
                        </div>
                      )}

                      {(branchIdVisible || visible) && (
                        <div className="input-item">
                          <label>Branch Id*</label>
                          <TextField
                            name="branch-id"
                            
                            className="input-field"
                            select
                            size="small"
                            // onChange={(e) =>
                            //   setBranchIdSuperadmin(e.target.value)
                            // }
                            onChange={handleBranchId}
                            value={branchIdSuperadmin}
                            disabled
                          >
                            {data2.length > 0 &&
                              data2.map((data, id) => (
                                <MenuItem
                                  key={id}
                                  value={data.branch_id}
                                  disabled={!data.is_active}
                                >
                                  {data.branch_id + " " + data.branch_name}
                                </MenuItem>
                              ))}
                          </TextField>
                        </div>
                      )}

                      {(sourceIdVisible || visible) && (
                        <div className="input-item">
                          <label>Source Code*</label>
                          <TextField
                            name="source-id"
                            
                            className="input-field"
                            select
                            size="small"
                            onChange={(e) =>
                              setsourceIdSuperadmin(e.target.value)
                            }
                            value={sourceIdSuperadmin}
                            disabled
                          >
                            {sourceData.length > 0 &&
                              sourceData.map((data, id) => (
                                <MenuItem
                                  key={id}
                                  value={data.staff_id}
                                  disabled={!data.is_active}
                                >
                                  {data.staff_id + " " + data.staff_name}
                                </MenuItem>
                              ))}
                          </TextField>
                        </div>
                      )}

                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Address Details</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleSubmitAddressDetails}>
                    <AccordionDetails>
                      <div className="address-1">
                        <div className="address-1-perm">
                          <h3>Permanent Address</h3>
                          <br />
                          <div className="input-item">
                            <label>Address*</label>
                            <br />
                            <TextField
                              className="input-field"
                              name="perm-address"
                              value={permanentAddress}
                              
                              onChange={(e) =>
                                setPermanentAddress(e.target.value)
                              }
                              placeholder="Address"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Pin Code*</label>
                            <br />
                            <TextField
                              className="input-field"
                              name="perm-pincode"
                              
                              value={permanentPinCode}
                              onChange={handleChangePermanentPinCode}
                              placeholder="Search Pin Code"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>State Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={permanentState}
                              
                              name="perm-state"
                              disabled
                              onChange={(e) =>
                                setPermanentState(e.target.value)
                              }
                              placeholder="State Name"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>City Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={permanentCity}
                              
                              name="perm-city"
                              disabled
                              onChange={(e) => setPermanentCity(e.target.value)}
                              placeholder="City Name"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Sub District*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={permanentSubDist}
                              
                              select
                              name="perm-city"
                              onChange={handlePermSubDistChange}
                              placeholder="Sub District"
                              size="small"
                            >
                              {permanentSubDistArr?.map((subDist) => {
                                return (
                                  <MenuItem key={subDist} value={subDist}>
                                    {subDist}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Locality/Village*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={permanentLocality}
                              select
                              
                              helperText={
                                negativeArea.permanent ? "Negative Area" : ""
                              }
                              error={negativeArea.permanent}
                              name="perm-city"
                              onChange={(e) =>
                                checkNegativeArea(
                                  e.target.value,
                                  setPermanentLocality,
                                  "permanent"
                                )
                              }
                              placeholder="Locality/Village"
                              size="small"
                            >
                              {permanentLocalityArr?.map((locality) => {
                                return (
                                  <MenuItem key={locality} value={locality}>
                                    {locality}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Landmark*</label>
                            <br />
                            <TextField
                              className="input-field"
                              name="perm-landmark"
                              value={permanentLandmark}
                              
                              placeholder="Landmark"
                              onChange={(e) =>
                                setPermanentLandmark(e.target.value)
                              }
                              size="small"
                              style={{ marginBottom: "1rem" }}
                            />
                          </div>
                        </div>
                        <div className="address-1-curr">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <h3 style={{ marginRight: "1rem" }}>Current Address</h3>
                          <input
                            type="checkbox"
                            checked={addressChecked}
                            onChange={(e) => handleCheckboxAddress(e)}
                            style={{ marginRight: "0.5rem" }}
                          />
                          <label>Same as Permanent Address</label>
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Address*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={currentAddress}
                    
                              name="curr-address"
                              onChange={(e) =>
                                setCurrentAddress(e.target.value)
                              }
                              placeholder="Address"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Pin Code*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={currentPinCode}
                              
                              name="curr-pincode"
                              onChange={handleChangeCurrentPinCode}
                              placeholder="Search Pin Code"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>State Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              name="curr-state"
                              disabled
                              value={currentState}
                              placeholder="State Name"
                              onChange={(e) => setCurrentState(e.target.value)}
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>City Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              name="curr-city"
                              disabled
                              value={currentCity}
                              onChange={(e) => setCurrentCity(e.target.value)}
                              placeholder="City Name"
                              size="small"
                            />
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Sub District*</label>
                            <br />
                            <TextField
                              select
                              className="input-field"
                              name="curr-city"
                              value={currentSubDist}
                              
                              onChange={handleCurrentSubDistChange}
                              placeholder="Sub District"
                              size="small"
                            >
                              {currentSubDistArr?.map((subDist) => {
                                return (
                                  <MenuItem key={subDist} value={subDist}>
                                    {subDist}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Locality/Village* </label>
                            <br />
                            <TextField
                              className="input-field"
                              select
                              
                              helperText={
                                negativeArea.current ? "Negative Area" : ""
                              }
                              error={negativeArea.current}
                              name="curr-city"
                              value={currentLocality}
                              onChange={(e) =>
                                checkNegativeArea(
                                  e.target.value,
                                  setCurrentLocality,
                                  "current"
                                )
                              }
                              placeholder="Locality/Village"
                              size="small"
                            >
                              {currentLocalityArr?.map((locality) => {
                                return (
                                  <MenuItem value={locality} key={locality}>
                                    {locality}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          </div>
                          <br />
                          <div className="input-item">
                            <label>Landmark*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={currentLandmark}
                              
                              name="curr-landmark"
                              onChange={(e) =>
                                setCurrentLandmark(e.target.value)
                              }
                              placeholder="Landmark"
                              size="small"
                            />
                          </div>
                          <br></br>
                        </div>
                      </div>

                      <div className="bank-details">
                        <div className="input-item">
                          <label>Residing at Current Address Since*(In Years)</label>
                          <br />
                          <TextField
                            className="input-field"
                            value={residingSince}
                            type="number"
                            name="number-of-active-loans"
                            onChange={(e) => setresidingSince(e.target.value)}
                            placeholder="Residing at Current Address Since"
                            size="small"
                          />
                        </div>
                      </div>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>

                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Bank Details</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleSubmitBankDetails}>
                    <AccordionDetails className="bank-details">
                      <div className="input-item">
                        <label>Collection Bank Search by IFSC*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={collectionBankIfscCode}
                          
                          name="collection-bank-ifsc-code"
                          onChange={handleChangeCollectionBankIfscCode}
                          placeholder="Collection Bank IFSC Code"
                          size="small"
                        />
                      </div>
                      <div className="input-item">
                        <label>Collection Bank Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={collectionBankName}
                          
                          disabled
                          onChange={(e) =>
                            setCollectionBankName(e.target.value)
                          }
                          name="collection-bank-name"
                          placeholder="Collection Bank Name"
                          size="small"
                        ></TextField>
                      </div>
                      <div className="input-item">
                        <label>Collection Bank Branch*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={collectionBankBranch}
                          disabled
                          onChange={(e) =>
                            setCollectionBankBranch(e.target.value)
                          }
                          name="collection-bank-branch"
                          placeholder="Collection Bank Branch"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Collection Bank type*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          
                          name="collection-bank-type"
                          value={collectionBankType}
                          size="small"
                          onChange={(e) =>
                            setCollectionBankType(e.target.value)
                          }
                        >
                          <MenuItem value="SAVINGS">SAVINGS</MenuItem>
                          <MenuItem value="CURRENT">CURRENT</MenuItem>
                          <MenuItem value="CC/OD">CC/OD</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-item">
                        <label>Collection Bank Account Number*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={collectionBankAccountNumber}
                          
                          name="collection-bank-account"
                          onChange={(e) =>
                            setCollectionBankAccountNumber(e.target.value)
                          }
                          placeholder="Collection Bank Account Number"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Confirm Collection Bank Account Number*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={confirmcollectionBankAccountNumber}
                          
                          name="collection-bank-account"
                          onChange={(e) =>
                            setconfirmCollectionBankAccountNumber(e.target.value)
                          }
                          placeholder="Confirm Collection Bank Account Number"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Collection Beneficiary Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={collectionBeneficiaryName}
                          
                          onChange={(e) =>
                            setCollectionBeneficiaryName(e.target.value)
                          }
                          name="collection-beneficiary-name"
                          placeholder="Collection Beneficiary Name"
                          size="small"
                        />
                      </div>
                      <br />
                      <div className="input-item">
                        <br />
                        <input
                          type="checkbox"
                          checked={bankChecked}
                          onChange={(e) => handleCheckboxBankDetails(e)}
                        ></input>
                        <label>Same as Collection account details</label>
                        <br></br>
                      </div>
                      <br></br>
                      <div className="input-item">
                        <label>Disbursement Bank Search by IFSC*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={disbursementBankIfscCode}
                          name="disbursement-bank-ifsc-code"
                          onChange={handleChangeDisbursementBankIfscCode}
                          placeholder="Disbursement Bank IFSC Code"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Disbursement Bank Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={disbursementBankName}
                          disabled
                          name="disbursement-bank-name"
                          onChange={(e) =>
                            setDisbursementBankName(e.target.value)
                          }
                          placeholder="Disbursement Bank Name"
                          size="small"
                        ></TextField>
                      </div>

                      <div className="input-item">
                        <label>Disbursement Bank Branch*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={disbursementBankBranch}
                          disabled
                          onChange={(e) =>
                            setDisbursementBankBranch(e.target.value)
                          }
                          name="collection-bank-branch"
                          placeholder="Disbursement Bank Branch"
                          size="small"
                        />
                      </div>
                      <div className="input-item">
                        <label>Disbursement Bank type*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          name="collection-bank-type"
                          value={disbursementBankType}
                          size="small"
                          onChange={(e) =>
                            setDisbursementBankType(e.target.value)
                          }
                        >
                          <MenuItem value="SAVINGS">SAVINGS</MenuItem>
                          <MenuItem value="CURRENT">CURRENT</MenuItem>
                          <MenuItem value="CC/OD">CC/OD</MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Disbursement Bank Account Number*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={disbursementBankAccountNumber}
                          name="disbursement-bank-account-number"
                          onChange={(e) =>
                            setDisbursementBankAccountNumber(e.target.value)
                          }
                          placeholder="Disbursement Bank Account Number"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Confirm Disbursement Bank Account Number*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={confirmdisbursementBankAccountNumber}
                          
                          name="disbursement-bank-account-number"
                          onChange={(e) =>
                            setconfirmdisbursementBankAccountNumber(e.target.value)
                          }
                          placeholder="Confirm Disbursement Bank Account Number"
                          size="small"
                        />
                      </div>

                      <div className="input-item">
                        <label>Disbursement Beneficiary Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={disbursementBeneficiaryName}
                          
                          onChange={(e) =>
                            setDisbursementBeneficiaryName(e.target.value)
                          }
                          name="disbursement-beneficiary-name"
                          placeholder="Disbursement Beneficiary Name"
                          size="small"
                        />
                      </div>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Reference Details</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleReferenceDetails}>
                    <AccordionDetails>
                      {references.map((reference, index) => (
                        <div key={index} className="bank-details">
                          <div className="input-item">
                            <label>Reference Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={reference.referenceName}
                              
                              name="referenceName"
                              onChange={(e) =>
                                handleReferenceInputChange(index, e)
                              }
                              placeholder="Reference Name"
                              size="small"
                            />
                          </div>
                          <div className="input-item">
                            <label>Reference Number*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={reference.referenceNumber}
                              
                              name="referenceNumber"
                              onChange={(e) =>
                                handleReferenceInputChange(index, e)
                              }
                              placeholder="Reference Number"
                              size="small"
                              type="number"
                            />
                          </div>
                          <div className="input-item">
                            <label>Reference Address*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={reference.referenceAddress}
                              
                              name="referenceAddress"
                              onChange={(e) =>
                                handleReferenceInputChange(index, e)
                              }
                              placeholder="Reference Address"
                              size="small"
                            />
                          </div>
                          <div className="input-item">
                            <label>Relationship with Applicant*</label>
                            <br />
                            <TextField
                              className="input-field"
                              select
                              value={reference.relationshipwithApplicant}
                              
                              name="relationshipwithApplicant"
                              onChange={(e) =>
                                handleReferenceInputChange(index, e)
                              }
                              placeholder="Relationship with Applicant"
                              size="small"
                            >
                              {index === 0
                                ? <MenuItem value="FRIEND">Friend</MenuItem>
                                : relationshipOptions.map((option) => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))
                              }
                              {/* <MenuItem value="FRIEND">Friend</MenuItem>
                              <MenuItem value="BROTHER">
                                Brother
                              </MenuItem>
                              <MenuItem value="SISTER">
                                Sister
                              </MenuItem>
                              <MenuItem value="FATHER">
                                Father
                              </MenuItem>
                              <MenuItem value="MOTHER">
                                Mother
                              </MenuItem>
                              <MenuItem value="SON">
                                Son
                              </MenuItem>
                              <MenuItem value="DAUGHTER">
                                Daughter
                              </MenuItem>
                              <MenuItem value="SON-IN-LAW">
                                Son-In-law
                              </MenuItem>
                              <MenuItem value="SISTER-IN-LAW">
                                Sister-in-law
                              </MenuItem>
                              <MenuItem value="FATHER-IN LAW">
                                Father-in law
                              </MenuItem>
                              <MenuItem value="MOTHER-IN-LAW">
                                Mother-In-Law
                              </MenuItem>
                              <MenuItem value="SPOUSE">
                                Spouse
                              </MenuItem> */}
                            </TextField>
                          </div>
                        </div>
                      ))}
                      <br />
                      <Button variant="contained" onClick={handleAddReference}>
                        Add
                      </Button>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>
                      Applicant’s Family Details
                    </p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleApplicantDetails}>
                    <AccordionDetails>
                      {applicants.map((applicant, index) => (
                        <div key={index} className="bank-details">
                          <div className="input-item">
                            <label>Name*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={applicant.name}
                              
                              name="name"
                              onChange={(e) =>
                                handleApplicantInputChange(index, e)
                              }
                              placeholder="Name"
                              size="small"
                            />
                          </div>
                          <div className="input-item">
                            <label>Relationship*</label>
                            <br />
                            <TextField
                              className="input-field"
                              select
                              value={applicant.relationship}
                              
                              name="relationship"
                              onChange={(e) =>
                                handleApplicantInputChange(index, e)
                              }
                              placeholder="Relationship"
                              size="small"
                            >
                              <MenuItem value="FRIEND">Friend</MenuItem>
                              <MenuItem value="BROTHER">
                                Brother
                              </MenuItem>
                              <MenuItem value="SISTER">
                                Sister
                              </MenuItem>
                              <MenuItem value="FATHER">
                                Father
                              </MenuItem>
                              <MenuItem value="MOTHER">
                                Mother
                              </MenuItem>
                              <MenuItem value="SON">
                                Son
                              </MenuItem>
                              <MenuItem value="DAUGHTER">
                                Daughter
                              </MenuItem>
                              <MenuItem value="SON-IN-LAW">
                                Son-In-law
                              </MenuItem>
                              <MenuItem value="SISTER-IN-LAW">
                                Sister-in-law
                              </MenuItem>
                              <MenuItem value="FATHER-IN LAW">
                                Father-in law
                              </MenuItem>
                              <MenuItem value="MOTHER-IN-LAW">
                                Mother-In-Law
                              </MenuItem>
                              <MenuItem value="SPOUSE">
                                Spouse
                              </MenuItem>
                            </TextField>
                          </div>
                          <div className="input-item">
                            <label>Age*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={applicant.age}
                              
                              name="age"
                              onChange={(e) =>
                                handleApplicantInputChange(index, e)
                              }
                              placeholder="Age"
                              size="small"
                            />
                          </div>
                          <div className="input-item">
                            <label>Occupation*</label>
                            <br />
                            <TextField
                              className="input-field"
                              select
                              value={applicant.occupation}
                              
                              name="occupation"
                              placeholder="Occupation"
                              onChange={(e) =>
                                handleApplicantInputChange(index, e)
                              }
                              size="small"
                            >
                              <MenuItem value="SALARIED">SALARIED</MenuItem>
                              <MenuItem value="SELF-EMPLOYED">
                                SELF-EMPLOYED
                              </MenuItem>
                              <MenuItem value="STUDENT">Student</MenuItem>
                              <MenuItem value="HOUSEWIFE">
                                Housewife
                              </MenuItem>
                              <MenuItem value="RETIRED">Retired</MenuItem>
                            </TextField>
                          </div>
                          <div className="input-item">
                            <label>Phone*</label>
                            <br />
                            <TextField
                              className="input-field"
                              value={applicant.phone}
                              
                              name="phone"
                              onChange={(e) =>
                                handleApplicantInputChange(index, e)
                              }
                              placeholder="Phone"
                              size="small"
                            />
                          </div>
                        </div>
                      ))}
                      <br />
                      <Button variant="contained" onClick={handleAddApplicant}>
                        Add
                      </Button>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>
                      Primary Occupation Details
                    </p>
                  </AccordionSummary>
                  <form action="" onSubmit={handlePrimaryBusinessDetails}>
                    <AccordionDetails>
                    {profession === "SALARIED" ? (
                        <div>
                          <div className="bank-details">
                            <div className="input-item">
                              <label>Nature of Employer*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="nature-of-business"
                                value={businessNature}
                                size="small"
                                onChange={(e) =>
                                  setBusinessNature(e.target.value)
                                }
                              >
                                {natureOfBusinessArray.map(
                                  (businessNature, i) => (
                                    <MenuItem
                                      key={i}
                                      value={natureOfBusinessArray[i]}
                                    >
                                      {businessNature}
                                    </MenuItem>
                                  )
                                )}
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Employer Company Type</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="company-type"
                                value={companyType}
                                size="small"
                                onChange={(e) => setCompanyType(e.target.value)}
                              >
                                <MenuItem value="PROPRIETORSHIP">
                                  PROPRIETORSHIP
                                </MenuItem>
                                <MenuItem value="PARTNERSHIP">
                                  PARTNERSHIP
                                </MenuItem>
                                <MenuItem value="LLP">
                                  LLP
                                </MenuItem>
                                <MenuItem value="PVT LTD">
                                  PVT LTD
                                </MenuItem>
                                <MenuItem value="PUBLIC LTD">
                                  PUBLIC LTD
                                </MenuItem>
                                <MenuItem value="TRUST">
                                  TRUST
                                </MenuItem>
                                <MenuItem value="NGO">
                                  NGO
                                </MenuItem>
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Employer Name*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={employerName}
                                name="employer-name"
                                onChange={(e) => EmployerName(e)}
                                placeholder="Employer Name"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Department</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                value={department}
                                name="employer-name"
                                onChange={(e) =>
                                  setdepartment(e.target.value)
                                }
                                placeholder="Department"
                                size="small"
                              >
                                <MenuItem value="HR">HR</MenuItem>
                                <MenuItem value="SALES">SALES</MenuItem>
                                <MenuItem value="FINANACE">
                                  FINANACE
                                </MenuItem>
                                <MenuItem value="OPERATIONS">
                                  OPERATIONS
                                </MenuItem>
                                <MenuItem value="PRODUCTION">
                                  PRODUCTION
                                </MenuItem>
                                <MenuItem value="IT">
                                  IT
                                </MenuItem>
                                <MenuItem value="ACCOUNTS">
                                  ACCOUNTS
                                </MenuItem>
                                <MenuItem value="LEGAL">
                                  LEGAL
                                </MenuItem>
                                <MenuItem value="COLLECTIONS">
                                  COLLECTIONS
                                </MenuItem>
                                <MenuItem value="CREDIT">
                                  CREDIT
                                </MenuItem>
                                <MenuItem value="MARKETING">
                                  MARKETING
                                </MenuItem>
                                <MenuItem value="CUSTOMER SERVICE">
                                  CUSTOMER SERVICE
                                </MenuItem>
                                <MenuItem value="RESEARCH">
                                  RESEARCH
                                </MenuItem>
                                <MenuItem value="ANALYSTICS">
                                  ANALYSTICS
                                </MenuItem>
                                <MenuItem value="ADMIN">
                                  ADMIN
                                </MenuItem>
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Designation</label>
                              <br />
                              <input
                                type="text"
                                className="input-field"
                                value={designationName}
                                name="designation-name"
                                onChange={(e) =>
                                  setDesignationName(e.target.value)
                                }
                                placeholder="Designation"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>
                                Duration with Current Employer (In Months)*
                              </label>
                              <br />
                              <TextField
                                className="input-field"
                                value={durationWithCurrentEmployer}
                                name="duration-with-current-employer"
                                onChange={(e) =>
                                  setDurationWithCurrentEmployer(e.target.value)
                                }
                                placeholder="Duration with Current Employer (In Months)"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Total Work Experience (In Months)*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={totalWorkExperience}
                                name="total-work-experience"
                                onChange={(e) =>
                                  setTotalWorkExperience(e.target.value)
                                }
                                placeholder="Total Work Experience (In Months)"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Salary Mode</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="salary-mode"
                                value={salaryMode}
                                size="small"
                                onChange={(e) => setSalaryMode(e.target.value)}
                              >
                                <MenuItem value="CASH">Cash</MenuItem>
                                <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                <MenuItem value="BANK TRANSFER">
                                  Bank Transfer
                                </MenuItem>
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Current Employmenet Salary (Monthly)*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={currentSalary}
                                name="current-salary"
                                onChange={(e) =>
                                  setCurrentSalary(e.target.value)
                                }
                                placeholder="Current Salary"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Previous Employment Salary (Monthly)</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={prevSalary}
                                name="previous-salary"
                                onChange={(e) => setPrevSalary(e.target.value)}
                                placeholder="Previous Salary"
                                size="small"
                                type="number"
                              />
                            </div>

                            <div className="input-item">
                              <label>Office Number*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={officeNumber}
                                name="office-number"
                                onChange={(e) =>
                                  setOfficeNumber(e.target.value)
                                }
                                placeholder="Office Number"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Office HR Number*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={officeHrNumber}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setOfficeHrNumber(e.target.value)
                                }
                                placeholder="Office HR Number"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Employee Code*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={employeeCode}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setEmployeeCode(e.target.value)
                                }
                                placeholder="Employee Code"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Date of Joining*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={dateofJoining}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setdateofJoining(e.target.value)
                                }
                                placeholder="Date of Joining"
                                size="small"
                                type="date"
                              />
                            </div>

                            <div className="input-item">
                              <label>Industry*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="industry"
                                value={industry}
                                size="small"
                                onChange={(e) => setIndustry(e.target.value)}
                              >
                                {industryArray.map((industry, i) => (
                                  <MenuItem key={i} value={industryArray[i]}>
                                    {industry}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Sector*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="sector"
                                value={sector}
                                size="small"
                                onChange={(e) => setSector(e.target.value)}
                              >
                                {sectorArray.map((sector, i) => (
                                  <MenuItem key={i} value={sectorArray[i]}>
                                    {sector}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Subsector*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="subsector"
                                value={subsector}
                                size="small"
                                onChange={(e) => setSubsector(e.target.value)}
                              >
                                {subsectorArray.map((subsector, i) => (
                                  <MenuItem key={i} value={subsectorArray[i]}>
                                    {subsector}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </div>
                            <br></br>
                            <div className="input-item">
                            <input
                            type="checkbox"
                            checked={primaryCompanyChecked}
                            onChange={(e) => handlePrimaryCompanyCheckbox(e)}
                            style={{ margin: "1rem 0" }}
                          ></input>
                          <label>  Same as Current Residence Address </label>
                          <br></br>
                          </div>

                          </div>
                          <div className="primary-business-address">
                            <div className="input-item">
                              <label>Address*</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={primaryBorrowerCompanyAddress}
                                name="officialAddress"
                                onChange={(e) =>
                                  setprimaryBorrowerCompanyAddress(
                                    e.target.value
                                  )
                                }
                                placeholder="Address"
                                size="small"
                              />
                            </div>

                            <div className="input-item">
                              <label>Pin Code*</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialPinCode"
                                value={primaryBorrowerCompanyPincode}
                                placeholder="Search Pin Code"
                                onChange={handlePrimaryCompanyPincode}
                                size="small"
                              />
                            </div>

                            <div className="input-item">
                              <label>State Name*</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialState"
                                value={primaryBorrowerCompanyState}
                                disabled
                                onChange={(e) =>
                                  setprimaryBorrowerCompanyState(e.target.value)
                                }
                                placeholder="State Name"
                                size="small"
                              />
                            </div>

                            <div className="input-item">
                              <label>City Name*</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialCity"
                                value={primaryBorrowerCompanyCity}
                                disabled
                                placeholder="City Name"
                                onChange={(e) =>
                                  setprimaryBorrowerCompanyCity(e.target.value)
                                }
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Sub District*</label>
                              <br />
                              <TextField
                                select
                                className="input-field"
                                name="officialSubDist"
                                value={primaryBorrowerCompanySubDist}
                                placeholder="Sub District"
                                onChange={handleSubDistPrimaryCompanyChange}
                                size="small"
                              >
                                {primaryBorrowerCompanySubDistArr?.map(
                                  (subDist) => {
                                    return (
                                      <MenuItem key={subDist} value={subDist}>
                                        {subDist}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </TextField>
                            </div>

                            <div className="input-item">
                              <label>Locality/Village*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                helperText={
                                  negativeAreaCompanyPrimary
                                    ? "Negative Area"
                                    : ""
                                }
                                error={negativeAreaCompanyPrimary}
                                name="officialLocality"
                                value={primaryBorrowerCompanyLocality}
                                placeholder="Locality/Village"
                                onChange={(e) =>
                                  checkNegativePrimaryCompanyArea(
                                    e.target.value,
                                    setprimaryBorrowerCompanyLocality,
                                    "CompanyLocality"
                                  )
                                }
                                size="small"
                              >
                                {primaryBorrowerCompanyLocalityArr?.map(
                                  (locality) => {
                                    return (
                                      <MenuItem key={locality} value={locality}>
                                        {locality}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </TextField>
                            </div>

                            <div className="input-item">
                              <label>Landmark</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={primaryBorrowerCompanyLandmark}
                                name="officialLandmark"
                                onChange={(e) =>
                                  setprimaryBorrowerCompanyLandmark(
                                    e.target.value
                                  )
                                }
                                placeholder="Landmark"
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="bank-details">
                        <div className="input-item">
                        <label>Loan Type*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          name="type-of-loan"
                          value={typeOfLoan}
                          size="small"
                          onChange={(e) =>
                            setTypeOfLoan(e.target.value)
                          }
                        >
                          <MenuItem value="CATTLE LOAN">Cattle Loan</MenuItem>
                          <MenuItem value="MSME LOAN">MSME Loan</MenuItem>
                        </TextField>
                      </div>
                          <br />
                          {typeOfLoan === "CATTLE LOAN" ? (
                            <>
                              <div className="input-item">
                                <label>Business Type*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  name="type-of-business"
                                  value={typeOfBusiness}
                                  size="small"
                                  onChange={(e) =>
                                    setTypeOfBusiness(e.target.value)
                                  }
                                >
                                  <MenuItem value="DAIRY">DAIRY (CO-OPERATIVE)</MenuItem>
                                  <MenuItem value="DAIRY (OPEN MARKET)">
                                    DAIRY (OPEN MARKET)
                                  </MenuItem>
                                  <MenuItem value="DAIRY (PRIVATE)">
                                    DAIRY (PRIVATE)
                                  </MenuItem>
                                </TextField>
                              </div>

                              {typeOfBusiness !== "DAIRY" ? (
                                <div className="input-item">
                                  <label>Business Name*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessName}
                                    name="business-name"
                                    onChange={(e) => handlebusinessName(e)}
                                    placeholder="Business Name"
                                    size="small"
                                  />
                                </div>
                              ) : (
                                <div className="input-item">
                                  <label>Mandli Name</label>
                                  <Autocomplete
                                    value={businessName}
                                    disablePortal
                                    id="combo-box-demo"
                                    options={mandliArr}
                                    size="small"
                                    onChange={handleMandliChange}
                                    sx={{ width: "36vw" }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        onChange={mandliSuggestions}
                                      />
                                    )}
                                  />
                                </div>
                              )}
                              {typeOfBusiness === "DAIRY" ? (
                                <>
                                  <div className="input-item">
                                    <label>Mantri Name*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={MantriName}
                                      name="income"
                                      onChange={(e) =>
                                        setMantriName(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>
                                  <div className="input-item">
                                    <label>Mantri Number*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={MantriNumber}
                                      name="income"
                                      onChange={(e) =>
                                        setMantriNumber(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                              <div className="input-item">
                                <label>Income Mode*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  name="salary-mode"
                                  value={incomeMode}
                                  size="small"
                                  onChange={(e) => setIncomeMode(e.target.value)}
                                >
                                  <MenuItem value="CASH">Cash</MenuItem>
                                  <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                  <MenuItem value="BANK TRANSFER">
                                    Bank Transfer
                                  </MenuItem>
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Business Income(Monthly)*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={businessIncome}
                                  name="income"
                                  onChange={(e) =>
                                    setBusinessIncome(e.target.value)
                                  }
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Legal Status</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value="PROPRIETORSHIP"
                                  name="legal-status"
                                  size="small"
                                  disabled
                                />
                              </div>

                              <div className="input-item">
                                <label>Business IDs*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value="Milk Statement"
                                  name="business-id"
                                  size="small"
                                  disabled
                                />
                              </div>

                              <div className="input-item">
                                <label>Number of Years in Business(In Months)*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={businessVintage}
                                  name="income"
                                  onChange={(e) =>
                                    setbusinessVintage(e.target.value)
                                  }
                                  size="small"
                                />
                              </div>

                              <br></br>
                              <div className="input-item">
                                <input
                                  type="checkbox"
                                  checked={primaryBusinessChecked}
                                  onChange={(e) => handlePrimaryBusinessCheckbox(e)}
                                  style={{ margin: "1rem 0" }}
                                ></input>
                                <label>  Same as Current Residence Address </label>
                                <br></br>
                              </div>
                             <br></br>
                              <div className="input-item">
                                <label>Business Address*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={primaryBorrowerBusinessAddress}
                                  name="official-address"
                                  onChange={(e) =>
                                    setprimaryBorrowerBusinessAddress(
                                      e.target.value
                                    )
                                  }
                                  placeholder="Address"
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Pin Code*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="official-search-pincode"
                                  value={primaryBorrowerBusinessPincode}
                                  placeholder="Search Pin Code"
                                  onChange={handlePrimaryBusinessPincode}
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>State Name*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="official-state"
                                  value={primaryBorrowerBusinessState}
                                  disabled
                                  onChange={(e) =>
                                    setprimaryBorrowerBusinessState(
                                      e.target.value
                                    )
                                  }
                                  placeholder="State Name"
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>City Name*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="official-city"
                                  value={primaryBorrowerBusinessCity}
                                  disabled
                                  placeholder="City Name"
                                  onChange={(e) =>
                                    setprimaryBorrowerBusinessCity(e.target.value)
                                  }
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Sub District*</label>
                                <br />
                                <TextField
                                  select
                                  className="input-field"
                                  name="official-city"
                                  value={primaryBorrowerBusinessSubDist}
                                  placeholder="Sub District"
                                  onChange={handleSubDistPrimaryBusinessChange}
                                  size="small"
                                >
                                  {primaryBorrowerBusinessSubDistArr?.map(
                                    (subDist) => {
                                      return (
                                        <MenuItem key={subDist} value={subDist}>
                                          {subDist}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Locality/Village*</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  helperText={
                                    negativeAreaBusinessPrimary
                                      ? "Negative Area"
                                      : ""
                                  }
                                  error={negativeAreaBusinessPrimary}
                                  name="official-city"
                                  value={primaryBorrowerBusinessLocality}
                                  placeholder="Locality/Village"
                                  onChange={(e) =>
                                    checkNegativePrimaryBusinessArea(
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                >
                                  {primaryBorrowerBusinessLocalityArr?.map(
                                    (locality) => {
                                      return (
                                        <MenuItem key={locality} value={locality}>
                                          {locality}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Landmark</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={primaryBorrowerBusinessLandmark}
                                  name="official-landmark"
                                  onChange={(e) =>
                                    setprimaryBorrowerBusinessLandmark(
                                      e.target.value
                                    )
                                  }
                                  placeholder="Landmark"
                                  size="small"
                                />
                              </div>
                            </>
                          ) : null}

                          {typeOfLoan === "MSME LOAN" ? (
                            <>
                                  <div className="input-item">
                                    <label>Business Type*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      select
                                      name="type-of-business"
                                      value={typeOfBusiness}
                                      size="small"
                                      onChange={(e) =>
                                        setTypeOfBusiness(e.target.value)
                                      }
                                    >
                                      <MenuItem value="GROCERY">Grocery</MenuItem>
                                      <MenuItem value="VEGETABLE">Vegetable</MenuItem>
                                      <MenuItem value="MEDICAL">Medical</MenuItem>
                                      <MenuItem value="MANUFACTURING">
                                        Manufacturing
                                      </MenuItem>
                                      <MenuItem value="TRADING">Trading</MenuItem>
                                      <MenuItem value="AGRICULTURE">
                                        Agriculture
                                      </MenuItem>
                                      <MenuItem value="SERVICES">Services</MenuItem>
                                      <MenuItem value="FLOUR MILL">
                                        Flour Mill
                                      </MenuItem>
                                      <MenuItem value="DIAGNOSTIC CENTRE">
                                        Diagnostic Centre
                                      </MenuItem>
                                      <MenuItem value="DAIRY">DAIRY (CO-OPERATIVE)</MenuItem>
                                      <MenuItem value="DAIRY (OPEN MARKET)">
                                        DAIRY (OPEN MARKET)
                                      </MenuItem>
                                      <MenuItem value="DAIRY (PRIVATE)">
                                        DAIRY (PRIVATE)
                                      </MenuItem>
                                    </TextField>
                                  </div>
                                  {typeOfBusiness !== "DAIRY" ? (
                                    <div className="input-item">
                                      <label>Business Name*</label>
                                      <br />
                                      <TextField
                                        className="input-field"
                                        value={businessName}
                                        name="business-name"
                                        onChange={(e) => handlebusinessName(e)}
                                        placeholder="Business Name"
                                        size="small"
                                      />
                                    </div>
                                  ) : (
                                    <div className="input-item">
                                      <label>Mandli Name</label>
                                      <Autocomplete
                                        value={businessName}
                                        disablePortal
                                        id="combo-box-demo"
                                        options={mandliArr}
                                        size="small"
                                        onChange={handleMandliChange}
                                        sx={{ width: "36vw" }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            onChange={mandliSuggestions}
                                          />
                                        )}
                                      />
                                    </div>
                                  )}
                                  {typeOfBusiness === "DAIRY" ? (
                                    <>
                                      <div className="input-item">
                                        <label>Mantri Name*</label>
                                        <br />
                                        <TextField
                                          className="input-field"
                                          value={MantriName}
                                          name="income"
                                          onChange={(e) =>
                                            setMantriName(e.target.value)
                                          }
                                          size="small"
                                        />
                                      </div>
                                      <div className="input-item">
                                        <label>Mantri Number*</label>
                                        <br />
                                        <TextField
                                          className="input-field"
                                          value={MantriNumber}
                                          name="income"
                                          onChange={(e) =>
                                            setMantriNumber(e.target.value)
                                          }
                                          size="small"
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <div className="input-item">
                                    <label>Income Mode*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      select
                                      name="salary-mode"
                                      value={incomeMode}
                                      size="small"
                                      onChange={(e) => setIncomeMode(e.target.value)}
                                    >
                                      <MenuItem value="CASH">Cash</MenuItem>
                                      <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                      <MenuItem value="BANK TRANSFER">
                                        Bank Transfer
                                      </MenuItem>
                                    </TextField>
                                  </div>

                                  <div className="input-item">
                                    <label>Business Income(Monthly)*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessIncome}
                                      name="income"
                                      onChange={(e) =>
                                        setBusinessIncome(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Business Phone number*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessphoneNumber}
                                      name="income"
                                      onChange={(e) =>
                                        setbusinessphoneNumber(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Business Email*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      type="email"
                                      value={businessEmail}
                                      name="income"
                                      onChange={(e) =>
                                        setbusinessEmail(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>

                                  <p style={{ fontWeight: "bold" }}>
                                    Total Work Experience (In Months)
                                  </p>

                                  <br />
                                  <div className="input-item">
                                    <label>If Professional*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={IfProfessional}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setIfProfessional(e.target.value)
                                      }
                                      placeholder="If Professional"
                                      size="small"
                                      type="number"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>If Business*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={IfBusiness}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setIfBusiness(e.target.value)
                                      }
                                      placeholder="If Business"
                                      size="small"
                                      type="number"
                                    />
                                  </div>
                                  <div className="input-item">
                                    <label>Legal Status</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={legalStatus}
                                      select
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setlegalStatus(e.target.value)
                                      }
                                      placeholder="Legal Status"
                                      size="small"
                                      type="number"
                                    >
                                      <MenuItem value="PROPRIETORSHIP">
                                        PROPRIETORSHIP
                                      </MenuItem>
                                      <MenuItem value="PARTNERSHIP">
                                        PARTNERSHIP
                                      </MenuItem>
                                      <MenuItem value="LLP">
                                        LLP
                                      </MenuItem>
                                      <MenuItem value="PVT LTD">
                                        PVT LTD
                                      </MenuItem>
                                      <MenuItem value="PUBLIC LTD">
                                        PUBLIC LTD
                                      </MenuItem>
                                      <MenuItem value="TRUST">
                                        TRUST
                                      </MenuItem>
                                      <MenuItem value="NGO">
                                        NGO
                                      </MenuItem>
                                    </TextField>
                                  </div>

                                  <div className="input-item">
                                    <label>Workplace</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={workplace}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setworkplace(e.target.value)
                                      }
                                      placeholder="Workplace"
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Current Workplace Stability (Monthly)*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={currentWorkplace}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setcurrentWorkplace(e.target.value)
                                      }
                                      placeholder="Current Workplace Stability"
                                      size="small"
                                      type="number"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Business IDs*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessID}
                                      select
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setbusinessID(e.target.value)
                                      }
                                      placeholder="Business IDs"
                                      size="small"
                                      type="number"
                                    >
                                      <MenuItem value="UDHYAM">
                                        UDHYAM
                                      </MenuItem>
                                      <MenuItem value="GST">
                                        GST
                                      </MenuItem>
                                      <MenuItem value="SHOP & ESTABLISHMENT">
                                        SHOP & ESTABLISHMENT
                                      </MenuItem>
                                      <MenuItem value="GUMASTADARA">
                                        GUMASTADARA
                                      </MenuItem>
                                      <MenuItem value="PARTNERSHIP DEED">
                                        PARTNERSHIP DEED
                                      </MenuItem>
                                      <MenuItem value="COMPANY REGISTRATION (COI)">
                                        COMPANY REGISTRATION (COI)
                                      </MenuItem>
                                    </TextField>
                                  </div>

                                  <div className="input-item">
                                    <label>Workplace Size (Sqr.Ft.)</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={workplaceSize}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setWorkplaceSize(e.target.value)
                                      }
                                      placeholder="Workplace Size"
                                      size="small"
                                      type="number"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Number of Employees</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={numberofEmployees}
                                      name="total-work-experience"
                                      onChange={(e) =>
                                        setnumberofEmployees(e.target.value)
                                      }
                                      placeholder="Number of Employees"
                                      size="small"
                                      type="number"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Number of Years in Business(In Months)*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessVintage}
                                      name="income"
                                      onChange={(e) =>
                                        setbusinessVintage(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>
                                  <br></br>
                                  <div className="input-item">
                                <input
                                  type="checkbox"
                                  checked={primaryBusinessChecked}
                                  onChange={(e) => handlePrimaryBusinessCheckbox(e)}
                                  style={{ margin: "1rem 0" }}
                                ></input>
                                <label>  Same as Current Residence Address </label>
                              </div>
                              <br></br>                            
                                  <div className="input-item">
                                    <label>Business Address*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={primaryBorrowerBusinessAddress}
                                      name="official-address"
                                      onChange={(e) =>
                                        setprimaryBorrowerBusinessAddress(
                                          e.target.value
                                        )
                                      }
                                      placeholder="Address"
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Pin Code*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      name="official-search-pincode"
                                      value={primaryBorrowerBusinessPincode}
                                      placeholder="Search Pin Code"
                                      onChange={handlePrimaryBusinessPincode}
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>State Name*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      name="official-state"
                                      value={primaryBorrowerBusinessState}
                                      disabled
                                      onChange={(e) =>
                                        setprimaryBorrowerBusinessState(
                                          e.target.value
                                        )
                                      }
                                      placeholder="State Name"
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>City Name*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      name="official-city"
                                      value={primaryBorrowerBusinessCity}
                                      disabled
                                      placeholder="City Name"
                                      onChange={(e) =>
                                        setprimaryBorrowerBusinessCity(e.target.value)
                                      }
                                      size="small"
                                    />
                                  </div>

                                  <div className="input-item">
                                    <label>Sub District*</label>
                                    <br />
                                    <TextField
                                      select
                                      className="input-field"
                                      name="official-city"
                                      value={primaryBorrowerBusinessSubDist}
                                      placeholder="Sub District"
                                      onChange={handleSubDistPrimaryBusinessChange}
                                      size="small"
                                    >
                                      {primaryBorrowerBusinessSubDistArr?.map(
                                        (subDist) => {
                                          return (
                                            <MenuItem key={subDist} value={subDist}>
                                              {subDist}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </TextField>
                                  </div>

                                  <div className="input-item">
                                    <label>Locality/Village*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      select
                                      helperText={
                                        negativeAreaBusinessPrimary
                                          ? "Negative Area"
                                          : ""
                                      }
                                      error={negativeAreaBusinessPrimary}
                                      name="official-city"
                                      value={primaryBorrowerBusinessLocality}
                                      placeholder="Locality/Village"
                                      onChange={(e) =>
                                        checkNegativePrimaryBusinessArea(
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                    >
                                      {primaryBorrowerBusinessLocalityArr?.map(
                                        (locality) => {
                                          return (
                                            <MenuItem key={locality} value={locality}>
                                              {locality}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </TextField>
                                  </div>

                                  <div className="input-item">
                                    <label>Landmark</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={primaryBorrowerBusinessLandmark}
                                      name="official-landmark"
                                      onChange={(e) =>
                                        setprimaryBorrowerBusinessLandmark(
                                          e.target.value
                                        )
                                      }
                                      placeholder="Landmark"
                                      size="small"
                                    />
                                  </div>
                            </>
                          ) : null}
                        </div>
                      )}
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>
                      Surrogate Occupation Details
                    </p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleSurrogateDetails}>
                    <AccordionDetails>
                      {demoTypes.map((demoType, index) => (
                        <div key={index} className="input-item">
                          <label>Surrogate Profession Type</label>
                          <br />
                          <TextField
                            className="input-field"
                            select
                            name={`profession-type-${index}`}
                            value={demoType}
                            size="small"
                            sx={{ width: "40rem" }}
                            onChange={(e) =>
                              handleSurrogateProfession(index, e.target.value)
                            }
                          >
                            <MenuItem value="SALARIED">SALARIED</MenuItem>
                            <MenuItem value="SELF-EMPLOYED">
                              SELF-EMPLOYED
                            </MenuItem>
                          </TextField>
                          <br />
                          {demoType === "SALARIED" ? (
                            <>
                              <div className="bank-details">
                                <div className="input-item">
                                  <label>Nature of Employer</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    value={
                                      formData[index]?.NatureOfBusiness || ""
                                    }
                                    name={`nature-of-business-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "NatureOfBusiness",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  >
                                    {natureOfBusinessArray.map(
                                      (businessNature, i) => (
                                        <MenuItem
                                          key={i}
                                          value={natureOfBusinessArray[i]}
                                        >
                                          {businessNature}
                                        </MenuItem>
                                      )
                                    )}
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Employer Company Type</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    value={formData[index]?.CompanyType || ""}
                                    name={`company-type-${index}`}
                                    size="small"
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "CompanyType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value="PROPRIETORSHIP">
                                      PROPRIETORSHIP
                                    </MenuItem>
                                    <MenuItem value="PARTNERSHIP">
                                      PARTNERSHIP
                                    </MenuItem>
                                    <MenuItem value="LLP">
                                      LLP
                                    </MenuItem>
                                    <MenuItem value="PVT LTD">
                                      PVT LTD
                                    </MenuItem>
                                    <MenuItem value="PUBLIC LTD">
                                      PUBLIC LTD
                                    </MenuItem>
                                    <MenuItem value="TRUST">
                                      TRUST
                                    </MenuItem>
                                    <MenuItem value="NGO">
                                      NGO
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Employer Name</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.EmployerName || ""
                                    }
                                    name={`employer-Name-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "EmployerName",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Employer Name"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Department</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    value={
                                      formData[index]?.Department || ""
                                    }
                                    name={`department-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "Department",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Department"
                                    size="small"
                                  >
                                    <MenuItem value="HR">HR</MenuItem>
                                    <MenuItem value="SALES">SALES</MenuItem>
                                    <MenuItem value="FINANACE">
                                      FINANACE
                                    </MenuItem>
                                    <MenuItem value="OPERATIONS">
                                      OPERATIONS
                                    </MenuItem>
                                    <MenuItem value="PRODUCTION">
                                      PRODUCTION
                                    </MenuItem>
                                    <MenuItem value="IT">
                                      IT
                                    </MenuItem>
                                    <MenuItem value="ACCOUNTS">
                                      ACCOUNTS
                                    </MenuItem>
                                    <MenuItem value="LEGAL">
                                      LEGAL
                                    </MenuItem>
                                    <MenuItem value="COLLECTIONS">
                                      COLLECTIONS
                                    </MenuItem>
                                    <MenuItem value="CREDIT">
                                      CREDIT
                                    </MenuItem>
                                    <MenuItem value="MARKETING">
                                      MARKETING
                                    </MenuItem>
                                    <MenuItem value="CUSTOMER SERVICE">
                                      CUSTOMER SERVICE
                                    </MenuItem>
                                    <MenuItem value="RESEARCH">
                                      RESEARCH
                                    </MenuItem>
                                    <MenuItem value="ANALYSTICS">
                                      ANALYSTICS
                                    </MenuItem>
                                    <MenuItem value="ADMIN">
                                      ADMIN
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Designation</label>
                                  <br />
                                  <input
                                    type="text"
                                    className="input-field"
                                    value={
                                      formData[index]?.DesignationName || ""
                                    }
                                    name={`designation-name-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "DesignationName",
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      height: "2.5rem",
                                      borderRadius: "5px",
                                      border: "1px solid lightgray",
                                    }}
                                  />
                                </div>
                                <div className="input-item">
                                  <label>
                                    Duration with Current Employer (In Months)
                                  </label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]
                                        ?.DurationWithCurrentEmployer || ""
                                    }
                                    name={`duration-with-current-employer-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "DurationWithCurrentEmployer",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    type="number"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Salary Mode</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    size="small"
                                    name={`salary-mode-${index}`}
                                    value={formData[index]?.SalaryMode || ""}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "SalaryMode",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value="CASH">Cash</MenuItem>
                                    <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                    <MenuItem value="BANK TRANSFER">
                                      Bank Transfer
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Current Employment Salary(Monthly)</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.CurrentSalary || ""}
                                    name={`current-salary-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "CurrentSalary",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    type="number"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Previous Employment Salary (Monthly)</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.PrevSalary || ""}
                                    name={`prev-salary-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "PrevSalary",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    type="number"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Total Work Experience (In Months)</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.JobVintage || ""}
                                    name={`job-vintage-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "JobVintage",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    type="number"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Employee code</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.EmployeeCode || ""
                                    }
                                    name={`Employee-code-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "EmployeeCode",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Employee code"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Date of joining</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.Dateofjoining || ""
                                    }
                                    name={`Date-of-joining-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "Dateofjoining",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Date of joining"
                                    size="small"
                                    type="date"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Office Number</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.OfficeNumber || ""}
                                    name={`office-number-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "OfficeNumber",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Office HR Number</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.OfficeHrNumber || ""
                                    }
                                    name={`office-hr-number-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "OfficeHrNumber",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    type="number"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>Industry</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    name={`industry-${index}`}
                                    value={
                                      formData[index]?.Industry || ""
                                    }
                                    size="small"
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "Industry",
                                        e.target.value
                                      )
                                    }                              >
                                    {industryArray.map((industry, i) => (
                                      <MenuItem key={i} value={industryArray[i]}>
                                        {industry}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Sector</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    size="small"
                                    value={
                                      formData[index]?.Sector || ""
                                    }
                                    name={`sector-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "Sector",
                                        e.target.value
                                      )
                                    }
                                  >
                                    {sectorArray.map((sector, i) => (
                                      <MenuItem key={i} value={sectorArray[i]}>
                                        {sector}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Subsector</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    size="small"
                                    value={
                                      formData[index]?.Subsector || ""
                                    }
                                    name={`subsector-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "Subsector",
                                        e.target.value
                                      )
                                    }
                                  >
                                    {subsectorArray.map((subsector, i) => (
                                      <MenuItem key={i} value={subsectorArray[i]}>
                                        {subsector}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <br></br>
                               <div className="input-item">
                                <input
                                type="checkbox"
                                checked={surrogateCompanyChecked}
                                onChange={(e) => handleSurrogateSalariedAddress(e)}
                                style={{ margin: "1rem 0" }}
                              ></input>
                              <label> Same as Current Residence Address </label>
                              </div>
                              </div>
                              <div className="primary-business-address">
                                <div className="input-item">
                                  <label>Company Address</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.CompanyAddress || ""
                                    }
                                    name={`company-address-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "CompanyAddress",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>Pin Code</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    name="officialPinCode"
                                    value={surrogateBorrowerCompanyPincode}
                                    placeholder="Search Pin Code"
                                    onChange={handleSurrogateCompanyPincode}
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>State Name</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    name="officialState"
                                    value={surrogateBorrowerCompanyState}
                                    disabled
                                    onChange={(e) =>
                                      setsurrogateBorrowerCompanyState(
                                        e.target.value
                                      )
                                    }
                                    placeholder="State Name"
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>City Name</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    name="officialCity"
                                    value={surrogateBorrowerCompanyCity}
                                    disabled
                                    placeholder="City Name"
                                    onChange={(e) =>
                                      setsurrogateBorrowerCompanyCity(
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Sub District</label>
                                  <br />
                                  <TextField
                                    select
                                    className="input-field"
                                    name="officialSubDist"
                                    value={surrogateBorrowerCompanySubDist}
                                    placeholder="Sub District"
                                    onChange={
                                      handleSubDistSurrogateCompanyChange
                                    }
                                    size="small"
                                  >
                                    {surrogateBorrowerCompanySubDistArr?.map(
                                      (subDist) => {
                                        return (
                                          <MenuItem
                                            key={subDist}
                                            value={subDist}
                                          >
                                            {subDist}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </TextField>
                                </div>

                                <div className="input-item">
                                  <label>Locality/Village</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    helperText={
                                      negativeAreaCompanySurrogate
                                        ? "Negative Area"
                                        : ""
                                    }
                                    error={negativeAreaCompanySurrogate}
                                    name="officialLocality"
                                    value={surrogateBorrowerCompanyLocality}
                                    placeholder="Locality/Village"
                                    onChange={(e) =>
                                      checkNegativeSurrogateCompanyArea(
                                        e.target.value,
                                        setsurrogateBorrowerCompanyLocality,
                                        "companyLocality"
                                      )
                                    }
                                    size="small"
                                  >
                                    {surrogateBorrowerCompanyLocalityArr?.map(
                                      (locality) => {
                                        return (
                                          <MenuItem
                                            key={locality}
                                            value={locality}
                                          >
                                            {locality}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </TextField>
                                </div>

                                <div className="input-item">
                                  <label>Landmark</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={
                                      formData[index]?.CompanyLandmark || ""
                                    }
                                    name={`company-landmark-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "CompanyLandmark",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      ))}
                      <br />
                      {demoTypes.map((demoType, index) =>
                        demoType === "SELF-EMPLOYED" ? (
                          <>
                            <div className="bank-details">
                              <div className="input-item">
                                <label>Business Type</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  size="small"
                                  name={`type-of-business-${index}`}
                                  value={formData[index]?.TypeOfBusiness || ""}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "TypeOfBusiness",
                                      e.target.value
                                    )
                                  }
                                >
                                  <MenuItem value="GROCERY">Grocery</MenuItem>
                                  <MenuItem value="DAIRY">Dairy (CO-OPERATIVE)</MenuItem>
                                  <MenuItem value="VEGETABLE">
                                    Vegetable
                                  </MenuItem>
                                  <MenuItem value="MEDICAL">Medical</MenuItem>
                                  <MenuItem value="Manufacturing">
                                    Manufacturing
                                  </MenuItem>
                                  <MenuItem value="Trading">Trading</MenuItem>
                                  <MenuItem value="Agriculture">
                                    Agriculture
                                  </MenuItem>
                                  <MenuItem value="Services">Services</MenuItem>
                                  <MenuItem value="Flour Mill">
                                    Flour Mill
                                  </MenuItem>
                                  <MenuItem value="DIAGNOSTIC CENTRE">
                                    Diagnostic Centre
                                  </MenuItem>
                                  <MenuItem value="DAIRY (OPEN MARKET)">
                                    DAIRY (OPEN MARKET)
                                  </MenuItem>
                                  <MenuItem value="DAIRY (PRIVATE)">
                                    DAIRY (PRIVATE)
                                  </MenuItem>
                                </TextField>
                              </div>
                              {formData[index]?.typeOfBusiness !== "DAIRY" ? (
                                <div className="input-item">
                                  <label>Business Name</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.BusinessName || ""}
                                    name={`business-name-${index}`}
                                    onChange={(e) =>
                                      handleSurrogateInputChange(
                                        index,
                                        "BusinessName",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                  />
                                </div>
                              ) : (
                                <div className="input-item">
                                  <label>Mandli Name</label>
                                  <Autocomplete
                                    id={`mandli-${index}`}
                                    disablePortal
                                    options={mandliArr}
                                    size="small"
                                    onChange={handleMandliChange}
                                    sx={{ width: "36vw" }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        onChange={mandliSuggestions}
                                      />
                                    )}
                                  />
                                </div>
                              )}
                              {formData[index]?.typeOfBusiness === "DAIRY" ? (
                                <>
                                  <div className="input-item">
                                    <label>Mantri Name</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={formData[index]?.MantriName || ""}
                                      name={`mantri-name-${index}`}
                                      onChange={(e) =>
                                        handleSurrogateInputChange(
                                          index,
                                          "MantriName",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                    />
                                  </div>
                                  <div className="input-item">
                                    <label>Mantri Number</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={
                                        formData[index]?.MantriNumber || ""
                                      }
                                      name={`mantri-number-${index}`}
                                      onChange={(e) =>
                                        handleSurrogateInputChange(
                                          index,
                                          "MantriNumber",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                              <div className="input-item">
                                <label>Business Income(Monthly)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.BusinessIncome || ""}
                                  name={`business-income-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessIncome",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Income Mode</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  value={
                                    formData[index]?.BusinessIncomeMode || ""
                                  }
                                  name={`business-income-mode-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessIncomeMode",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                >
                                  <MenuItem value="CASH">Cash</MenuItem>
                                  <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                  <MenuItem value="BANK TRANSFER">
                                    Bank Transfer
                                  </MenuItem>
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Business Phone number</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.BusinessPhone || ""}
                                  name={`business-phone-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessPhone",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Business Email</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.BusinessEmail || ""}
                                  name={`business-email-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessEmail",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Number of Years in Business(In Months)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.BusinessYears || ""}
                                  name={`business-years-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessYears",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>
                              <br />
                              <p style={{ fontWeight: "bold" }}>
                                Total Work Experience (In Months)
                              </p>

                              <br />
                              <div className="input-item">
                                <label>If Professional</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.IfProfessional || ""}
                                  name={`business-professional-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "IfProfessional",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                  type="number"
                                />
                              </div>

                              <div className="input-item">
                                <label>If Business</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.Ifbusiness || ""}
                                  name={`if-business-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "Ifbusiness",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                  type="number"
                                />
                              </div>

                              <div className="input-item">
                                <label>Legal Status</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  value={formData[index]?.LegalStatus || ""}
                                  name={`legal-Status-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "LegalStatus",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Legal Status"
                                  size="small"
                                >
                                  <MenuItem value="PROPRIETORSHIP">
                                    PROPRIETORSHIP
                                  </MenuItem>
                                  <MenuItem value="PARTNERSHIP">
                                    PARTNERSHIP
                                  </MenuItem>
                                  <MenuItem value="LLP">
                                    LLP
                                  </MenuItem>
                                  <MenuItem value="PVT LTD">
                                    PVT LTD
                                  </MenuItem>
                                  <MenuItem value="PUBLIC LTD">
                                    PUBLIC LTD
                                  </MenuItem>
                                  <MenuItem value="TRUST">
                                    TRUST
                                  </MenuItem>
                                  <MenuItem value="NGO">
                                    NGO
                                  </MenuItem>
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Workplace</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.Workplace || ""}
                                  name={`business-workplace-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "Workplace",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Workplace"
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>Current Workplace Stability (Monthly)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.CurrentWorkplace || ""}
                                  name={`current-workplace-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "CurrentWorkplace",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Current Workplace Stability"
                                  size="small"
                                  type="number"
                                />
                              </div>

                              <div className="input-item">
                                <label>Business IDs</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  value={formData[index]?.BusinessId || ""}
                                  name={`business-id-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessId",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Business IDs"
                                  size="small"
                                  type="number"
                                >
                                  <MenuItem value="UDHYAM">
                                    UDHYAM
                                  </MenuItem>
                                  <MenuItem value="GST">
                                    GST
                                  </MenuItem>
                                  <MenuItem value="SHOP & ESTABLISHMENT">
                                    SHOP & ESTABLISHMENT
                                  </MenuItem>
                                  <MenuItem value="GUMASTADARA">
                                    GUMASTADARA
                                  </MenuItem>
                                  <MenuItem value="PARTNERSHIP DEED">
                                    PARTNERSHIP DEED
                                  </MenuItem>
                                  <MenuItem value="COMPANY REGISTRATION (COI)">
                                    COMPANY REGISTRATION (COI)
                                  </MenuItem>
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Workplace Size (Sqr.Ft.)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.WorkplaceSize || ""}
                                  name={`workplace-size-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "WorkplaceSize",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Workplace Size (Sqr.Ft.)"
                                  size="small"
                                  type="number"
                                />
                              </div>

                              <div className="input-item">
                                <label>Number of Employees</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.NumberofEmployees || ""}
                                  name={`Number-of-Employees-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "NumberofEmployees",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Number of Employees"
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                              <input
                              type="checkbox"
                              checked={surrogateBusinessChecked}
                              onChange={(e) => handleSurrogateSelfEmployeedAddress(e)}
                              style={{ margin: "1rem 0" }}
                            ></input>
                            <label>  Same as Current Residence Address </label>
                            </div>
                            </div>
                            <div className="primary-business-address">
                              <div className="input-item">
                                <label>Business Address</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.BusinessAddress || ""}
                                  name={`business-address-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessAddress",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Pin Code</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialPinCode"
                                  value={surrogateBorrowerBusinessPincode}
                                  placeholder="Search Pin Code"
                                  onChange={handleSurrogateBusinessPincode}
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>State Name</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialState"
                                  value={surrogateBorrowerBusinessState}
                                  disabled
                                  onChange={(e) =>
                                    setsurrogateBorrowerBusinessState(
                                      e.target.value
                                    )
                                  }
                                  placeholder="State Name"
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>City Name</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialCity"
                                  value={surrogateBorrowerBusinessCity}
                                  disabled
                                  placeholder="City Name"
                                  onChange={(e) =>
                                    setsurrogateBorrowerBusinessCity(
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Sub District</label>
                                <br />
                                <TextField
                                  select
                                  className="input-field"
                                  name="officialSubDist"
                                  value={surrogateBorrowerBusinessSubDist}
                                  placeholder="Sub District"
                                  onChange={
                                    handleSubDistSurrogateBusinessChange
                                  }
                                  size="small"
                                >
                                  {surrogateBorrowerBusinessSubDistArr?.map(
                                    (subDist) => {
                                      return (
                                        <MenuItem key={subDist} value={subDist}>
                                          {subDist}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Locality/Village</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  helperText={
                                    negativeAreaBusinessSurrogate
                                      ? "Negative Area"
                                      : ""
                                  }
                                  error={negativeAreaBusinessSurrogate}
                                  name="officialLocality"
                                  value={surrogateBorrowerBusinessLocality}
                                  placeholder="Locality/Village"
                                  onChange={(e) =>
                                    checkNegativeSurrogateBusinessArea(
                                      e.target.value,
                                      setsurrogateBorrowerBusinessLocality,
                                      "businessLocality"
                                    )
                                  }
                                  size="small"
                                >
                                  {surrogateBorrowerBusinessLocalityArr?.map(
                                    (locality) => {
                                      return (
                                        <MenuItem
                                          key={locality}
                                          value={locality}
                                        >
                                          {locality}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </TextField>
                              </div>
                              <div className="input-item">
                                <label>Landmark</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={
                                    formData[index]?.BusinessLandmark || ""
                                  }
                                  name={`business-landmark-${index}`}
                                  onChange={(e) =>
                                    handleSurrogateInputChange(
                                      index,
                                      "BusinessLandmark",
                                      e.target.value
                                    )
                                  }
                                  size="small"
                                />
                              </div>
                            </div>
                          </>
                        ) : null
                      )}
                      <br />
                      <Button variant="contained" onClick={handleAddSurrogate}>
                        Add
                      </Button>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Obligations</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleObligationDetails}>
                    <AccordionDetails>
                      <div className="bank-details">
                        <div className="input-item">
                          <label>Total Active Loans*</label>
                          <br />
                          <TextField
                            className="input-field"
                            value={borrowernumberOfActiveLoans}
                            
                            type="number"
                            name="number-of-active-loans"
                            onChange={(e) =>
                              setborrowernumberOfActiveLoans(e.target.value)
                            }
                            placeholder="Total Active Loans"
                            size="small"
                          />
                        </div>
                        <div className="input-item">
                          <label>Total Monthly EMIs</label>
                          <br />
                          <TextField
                            className="input-field"
                            type="number"
                            value={borrowertotalMonthlyActiveEmiAmount}
                            name="total-monthly-active-emi-amount"
                            onChange={(e) =>
                              setborrowertotalMonthlyActiveEmiAmount(
                                e.target.value
                              )
                            }
                            placeholder="Total Monthly EMIs"
                            size="small"
                          />
                        </div>
                      </div>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Document</p>
                  </AccordionSummary>

                  <AccordionDetails>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Important: Size of documents must not exceed 1 MB*
                    </p>
                    <br />

                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>KYC Documents</p>
                      </AccordionSummary>

                      <AccordionDetails>
                        <div className="docs-add-borrower">
                          
                          {/* <div style={{ display: "flex", gap: "2rem" }}>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("reinitiate/link")}
                            >
                              Reinitiate Session
                            </button>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("fetch/link")}
                            >
                              Fetch Link
                            </button>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("fetch/data")}
                            >
                              Fetch Data
                            </button>
                            <button className="digi-kyc" onClick={copyLinkToClipboard}>Copy Link</button>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <label>eKyc Mode :</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>
                              {ekycMode}
                            </div> */}
                            {/* <div className="input-item">
                              <TextField
                                className="input-field"
                                name="ekycMode"
                                value={ekycMode}
                                disabled
                                size="small"
                                type="text"
                              />
                            </div> */}
                            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <label>eKyc Status :</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>
                              {ekycStatus}
                            </div> */}
                            {/* <div className="input-item">
                              <TextField
                                className="input-field"
                                name="ekycStatus"
                                value={ekycStatus}
                                disabled
                                size="small"
                                type="text"
                              />
                            </div> */}
                            {/* <Dialog open={openDialog}>
                              <DialogTitle>Choose KYC Option to proceed</DialogTitle>
                              <DialogContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('eKyc')}>e-Kyc</Button>
                                <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('Physical')}>Physical KYC</Button>
                              </DialogContent>
                            </Dialog>
                          </div> */}

                          <div className="input-item-doc">
                            <label style={{ fontWeight: "bold" }}>
                              Self Photo
                            </label>
                            <input
                              
                              type="file"
                              name="self-photo"
                              onChange={(e) => uploadSelfPhoto(e)}
                            />
                            {borrower_selfphoto ? (
                              <div>
                                <TaskIcon
                                  sx={{ color: "green", fontSize: "2rem" }} />
                              </div>
                            ) : (
                              ""
                            )}

                          </div>

                          <div className="input-item-doc-5">
                            <label style={{ fontWeight: "bold" }}>
                              Pan Card
                            </label>
                            <input
                              
                              type="file"
                              name="pancard"
                              onChange={(e) => uploadPancard(e)}
                            />
                            <div className="input-item">
                              <label style={{ fontWeight: "bold" }}>
                                Pan Number
                              </label>
                              <br />
                              <TextField
                                className="input-field-document"
                                name="pan-number"
                                disabled
                                style={{ backgroundColor: "rgb(216,216,216" }}
                                value={panNumber}
                                onChange={(e) => setPanNumber(e.target.value)}
                                placeholder="Pan Number"
                                size="small"
                              />
                            </div>

                            {/* <div className="input-item">
                              <label style={{ fontWeight: "bold" }}>
                                Name as on Pancard
                              </label>
                              <br />
                              <TextField
                                className="input-field-document"
                                name="name-on-pancard"
                                value={nameOnPancard}
                                disabled
                                style={{ backgroundColor: "rgb(216,216,216" }}
                                onChange={(e) =>
                                  setNameOnPancard(e.target.value)
                                }
                                placeholder="Pancard Name"
                                size="small"
                              />
                            </div> */}
                            <div className="input-item">
                              <label style={{ fontWeight: "bold" }}>Age</label>
                              <br />
                              <TextField
                                className="input-field-document"
                                name="age"
                                type="number"
                                value={age}
                                placeholder="Age"
                                disabled
                                style={{ backgroundColor: "rgb(216,216,216" }}
                                onChange={(e) => setAge(e.target.value)}
                                size="small"
                              />
                            </div>
                            {borrower_pancard ? (
                              <TaskIcon
                                sx={{ color: "green", fontSize: "2rem" }}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="input-item-doc-4">
                            <label style={{ fontWeight: "bold" }}>
                              Aadhar Card Front
                            </label>
                            <input
                              type="file"
                              
                              name="aadhar-card-front"
                              onChange={(e) => uploadAadharCardFront(e)}
                            />
                            <div className="input-item">
                              <label style={{ fontWeight: "bold" }}>
                                Aadhar Number (Masked/Encrypted)
                              </label>
                              <br />
                              <TextField
                                className="input-field-document"
                                name="aadhar-number"
                                value={aadharNumber}
                                disabled
                                style={{ backgroundColor: "rgb(216,216,216" }}
                                onChange={(e) =>
                                  setAadharNumber(e.target.value)
                                }
                                placeholder="Aadhar Number"
                                size="small"
                              />
                            </div>

                            {(decryptButtonVisible || visible) && (
                              <button style={{ background: "rgb(3,78,161)", color: "rgb(255,255,255)", borderRadius: "5px", cursor: "pointer", border: "none", padding: "5px 5px" }}
                                onClick={() => handleDecryptClick(aadharNumber, 'kycBorrower')}
                              >
                                Decrypt
                              </button>
                            )}

                            {infoData && (
                              <span style={{ fontWeight: 'bold' }}>
                                {infoData}
                              </span>
                            )}
                            
                            {borrower_aadhar_front ? (
                              <TaskIcon
                                sx={{ color: "green", fontSize: "2rem" }}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="input-item-doc">
                            <label style={{ fontWeight: "bold" }}>
                              Aadhar Card Back
                            </label>
                            <input
                              type="file"
                              name="aadhar-card-back"
                              
                              onChange={(e) => uploadAadharCardBack(e)}
                            />
                            {borrower_aadhar_back ? (
                              <TaskIcon
                                sx={{ color: "green", fontSize: "2rem" }}
                              />
                            ) : (
                              ""
                            )}
                            <button
                              className="digi-kyc"
                              onClick={uploadAadharCard}
                            >
                              Upload Aadhar Front and Back
                            </button>
                          </div>

                          <div className="input-item-doc">
                            <label style={{ fontWeight: "bold" }}>
                              Current Address Proof
                            </label>
                            <input
                              type="file"
                              
                              name="current-address-proof"
                              onChange={(e) => uploadCurrentAddressProof(e)}
                            />
                            {borrower_current_address_proof ? (
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ) : (
                              ""
                            )}

                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6rem",
                            }}
                          >
                            <label style={{ fontWeight: "bold" }}>
                              Other KYC Documents
                            </label>
                            <div style={{ width: "30%" }}>
                              <Select
                                value={kycDocuments}
                                onChange={(e) => handlekycdocuments(e)}
                                options={kyc}
                                isMulti
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          {kycDocuments?.length > 0 &&
                            kycDocuments?.map((val) => KycBox(val.label))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>Income Documents</p>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="input-bank-statement-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank Statement
                          </label>
                          <input
                            type="file"
                            
                            name="bank-statement"
                            onChange={(e) => uploadBankStatement(e)}
                          />
                          {borrower_bank_statement.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({borrower_bank_statement.length})
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="input-item-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank Statement Password (If Bank Statement Password
                            Protected)
                          </label>
                          <div className="input-item">
                            <TextField
                              name="password"
                              className="input-field-document"
                              value={password}
                              // type="password"
                              size="small"
                              placeholder="Password"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <button
                            className="digi-kyc"
                            onClick={uploadBankStatementPassword}
                          >
                            Upload Bank Statement Password
                          </button>
                        </div>

                        <div className="input-item-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank report Documents
                          </label>
                          <input
                            type="file"
                            name="bank-report-documents"
                            onChange={(e) => uploadBankReportDocuments(e)}
                          />
                          {borrower_bank_report_documents ? (
                            <TaskIcon
                              sx={{ color: "green", fontSize: "2rem" }}
                            />
                          ) : (
                            ""
                          )}

                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4rem",
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Other Income Documents
                          </label>
                          <div style={{ width: "30%" }}>
                            <Select
                              value={incomeDocuments}
                              className="select-box"
                              onChange={(e) => handleincomedocuments(e)}
                              options={Income}
                              isMulti
                            />
                          </div>
                        </div>
                        <div>
                          {incomeDocuments?.length > 0 &&
                            incomeDocuments?.map((val) => incomeBox(val.label))}
                        </div>

                      </AccordionDetails>
                    </Accordion>
                    {profession === "SALARIED" &&
                      <Accordion className="menu-item-add-borrower">
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p style={{ fontStyle: "italic" }}>
                            Employement Proof Documents
                          </p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="docs-add-borrower">
                            <div className="input-item-doc">
                              <label style={{ fontWeight: "bold" }}>
                                Company ID
                              </label>
                              <input
                                type="file"
                                name="company-id"
                                onChange={(e) => uploadCompanyId(e)}
                              />

                              {borrower_companyid ? (
                                <TaskIcon
                                  sx={{ color: "green", fontSize: "2rem" }}
                                />
                              ) : (
                                ""
                              )}

                            </div>
                            <div className="input-appointment-doc">
                              <label style={{ fontWeight: "bold" }}>
                                Appointment letter
                              </label>
                              <input
                                type="file"
                                name="employee-id"
                                onChange={(e) => uploadappointmentletter(e)}
                              />
                              {borrower_appoinment_letter.length > 0 ? (
                                <div>
                                  <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                  ({borrower_appoinment_letter.length})
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2rem",
                              }}
                            >
                              <label style={{ fontWeight: "bold" }}>
                                Other Employement Proof Documents
                              </label>

                              <div style={{ width: "30%" }}>
                                <Select
                                  value={employementDocuments}
                                  className="select-box"
                                  onChange={(e) => handleemployeedocuments(e)}
                                  options={Employement}
                                  isMulti
                                />
                              </div>
                            </div>
                            <div>
                              {employementDocuments?.length > 0 &&
                                employementDocuments?.map((val) => employeBox(val.label))}
                            </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }

                    {profession === "SELF-EMPLOYED" &&
                      <Accordion className="menu-item-add-borrower">
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                        >
                          <p style={{ fontStyle: "italic" }}>
                            Business Registration Proof Documents
                          </p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="docs-add-borrower">
                            <div className="input-electricity-doc">
                              <label style={{ fontWeight: "bold" }}>
                                Electricity Bill
                              </label>
                              <input
                                type="file"
                                name="electric-bill"
                                onChange={(e) => uploadElectricBill(e)}
                              />
                              {borrower_electricity_bill.length > 0 ? (
                                <div>
                                  <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                  ({borrower_electricity_bill.length})
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="business-photo">
                              <label style={{ fontWeight: "bold" }}>
                                Business Photo
                              </label>
                              <input
                                type="file"
                                name="business-photo"
                                onChange={(e) => uploadBusinessPhoto(e)}
                              />
                              {borrower_inside_shop_photo.length > 0 ? (
                                <div>
                                  <TaskIcon
                                    sx={{ color: "green", fontSize: "2rem" }}
                                  />
                                  ({borrower_inside_shop_photo.length})
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                         
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "3rem",
                              }}
                            >
                              <label style={{ fontWeight: "bold" }}>
                                Business Registration Proof
                              </label>
                              <div style={{ width: "30%" }}>
                                <Select
                                  value={businessProof}
                                  className="select-box"
                                  onChange={(e) => handlebusinessdocuments(e)}
                                  options={Business}
                                  isMulti
                                />
                              </div>
                            </div>

                            <div>
                              {businessProof?.length > 0 &&
                                businessProof?.map((val) => businessBox(val.label))}
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>Other Documents</p>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="input-misc-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Miscellaneous Documents
                          </label>
                          <input
                            type="file"
                            name="miscellaneous-documents"
                            onChange={(e) => uploadMiscellaneousDocuments(e)}
                          />
                          {borrower_misc_doc.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({borrower_misc_doc.length})
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="input-misc-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Cibil Report
                          </label>
                          <input
                            type="file"
                            name="miscellaneous-documents"
                            onChange={(e) => uploadcibilReport(e)}
                          />
                          {borrower_cibil_report.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({borrower_cibil_report.length})
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </AccordionDetails>
                </Accordion>

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <p style={{ fontWeight: "bold" }}>Extra Details</p>
                  </AccordionSummary>
                  <form action="" onSubmit={handleSubmitExtraDetails}>
                    <AccordionDetails className="bank-details">
                      <div className="input-item">
                        <label>Required Tenure</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={requiredTenure}
                          style={{ backgroundColor: "white" }}
                          name="required-tenure"
                          onChange={(e) => setRequiredTenure(e.target.value)}
                          placeholder="Required Tenure"
                          size="small"
                          type="number"
                        />
                      </div>
                      <div className="input-item">
                        <label>Required Amount</label>
                        <TextField
                          className="input-field"
                          value={requiredAmount}
                          style={{ backgroundColor: "white" }}
                          name="required-amount"
                          onChange={(e) => setRequiredAmount(e.target.value)}
                          placeholder="Required Amount"
                          size="small"
                          type="number"
                        />
                      </div>
                      <div className="input-item">
                        <label>Comment</label>
                        <TextField
                          className="input-field"
                          value={comment}
                          style={{ backgroundColor: "white" }}
                          name="comment"
                          onChange={(e) => setComment(e.target.value)}
                          placeholder="Comment"
                          size="small"
                        />
                      </div>
                      <div className="input-item">
                        <label> Analyst Access</label>
                        <TextField
                          className="input-field"
                          select
                          name="loan-officer-access"
                          style={{ backgroundColor: "white" }}
                          value={analystID}
                          size="small"
                          onChange={handleAnalyst}
                        >
                          {analyst.map((data, id) => (
                            <MenuItem key={id} value={data.staff_id}>
                              {data.staff_name}
                            </MenuItem>
                          ))}
                        </TextField>
                        <p>Please Select your Staff Name Only.</p>
                      </div>
                      <div className="input-item">
                        <label>Manager Access</label>
                        <TextField
                          className="input-field"
                          select
                          name="loan-officer-access"
                          style={{ backgroundColor: "white" }}
                          value={managerID}
                          size="small"
                          onChange={handleManager}
                        >
                          {manager.map((data, id) => (
                            <MenuItem key={id} value={data.staff_id}>
                              {data.staff_name}
                            </MenuItem>
                          ))}
                        </TextField>
                        <p>Please Select your Staff Name Only.</p>
                      </div>
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={handleToggleBorrowerStatus}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

    </>
  );
}
